/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */


import ApiClient from './ApiClient';
import AccountControllerDtoAccountCurrentNicknameUpdateRequest from './model/AccountControllerDtoAccountCurrentNicknameUpdateRequest';
import AccountControllerDtoAccountCurrentPowerUpdateRequest from './model/AccountControllerDtoAccountCurrentPowerUpdateRequest';
import AccountControllerDtoAccountDefaultInfoAccountPunishLightData from './model/AccountControllerDtoAccountDefaultInfoAccountPunishLightData';
import AccountControllerDtoAccountDefaultInfoNicknameChangeLogHistoryData from './model/AccountControllerDtoAccountDefaultInfoNicknameChangeLogHistoryData';
import AccountControllerDtoAccountDefaultInfoRequest from './model/AccountControllerDtoAccountDefaultInfoRequest';
import AccountControllerDtoAccountDefaultInfoResponse from './model/AccountControllerDtoAccountDefaultInfoResponse';
import AccountControllerDtoAccountDefaultInfoWithdrawalData from './model/AccountControllerDtoAccountDefaultInfoWithdrawalData';
import AccountControllerDtoAccountInventoryInfoAccountInventoryCar from './model/AccountControllerDtoAccountInventoryInfoAccountInventoryCar';
import AccountControllerDtoAccountInventoryInfoAccountInventoryCarBox from './model/AccountControllerDtoAccountInventoryInfoAccountInventoryCarBox';
import AccountControllerDtoAccountInventoryInfoAccountInventoryCarGemData from './model/AccountControllerDtoAccountInventoryInfoAccountInventoryCarGemData';
import AccountControllerDtoAccountInventoryInfoAccountInventoryGears from './model/AccountControllerDtoAccountInventoryInfoAccountInventoryGears';
import AccountControllerDtoAccountInventoryInfoAccountInventoryItems from './model/AccountControllerDtoAccountInventoryInfoAccountInventoryItems';
import AccountControllerDtoAccountInventoryInfoAccountInventorySpecialBox from './model/AccountControllerDtoAccountInventoryInfoAccountInventorySpecialBox';
import AccountControllerDtoAccountInventoryInfoAccountInventoryWallet from './model/AccountControllerDtoAccountInventoryInfoAccountInventoryWallet';
import AccountControllerDtoAccountInventoryInfoRequest from './model/AccountControllerDtoAccountInventoryInfoRequest';
import AccountControllerDtoAccountInventoryInfoResponse from './model/AccountControllerDtoAccountInventoryInfoResponse';
import AccountControllerDtoAccountListAccountData from './model/AccountControllerDtoAccountListAccountData';
import AccountControllerDtoAccountListRequest from './model/AccountControllerDtoAccountListRequest';
import AccountControllerDtoAccountListResponse from './model/AccountControllerDtoAccountListResponse';
import AccountControllerDtoAccountListWithdrawalData from './model/AccountControllerDtoAccountListWithdrawalData';
import AccountControllerDtoAccountPunishStatusUpdateRequest from './model/AccountControllerDtoAccountPunishStatusUpdateRequest';
import AccountControllerDtoWithdrawalCancelRequest from './model/AccountControllerDtoWithdrawalCancelRequest';
import AccountControllerDtoWithdrawalLogListRequest from './model/AccountControllerDtoWithdrawalLogListRequest';
import AccountControllerDtoWithdrawalRequest from './model/AccountControllerDtoWithdrawalRequest';
import AllowedConnectionIpControllerDtoAllowedConnectionIpCreateRequest from './model/AllowedConnectionIpControllerDtoAllowedConnectionIpCreateRequest';
import AllowedConnectionIpControllerDtoAllowedConnectionIpListRequest from './model/AllowedConnectionIpControllerDtoAllowedConnectionIpListRequest';
import AllowedConnectionIpControllerDtoAllowedConnectionIpListResponse from './model/AllowedConnectionIpControllerDtoAllowedConnectionIpListResponse';
import AllowedConnectionIpControllerDtoAllowedConnectionIpRemoveRequest from './model/AllowedConnectionIpControllerDtoAllowedConnectionIpRemoveRequest';
import AllowedConnectionIpData from './model/AllowedConnectionIpData';
import ApiRoleData from './model/ApiRoleData';
import AuthorizationGroupData from './model/AuthorizationGroupData';
import Balance from './model/Balance';
import BaseResponse from './model/BaseResponse';
import CampaignControllerDtoAppDetailAppDetailDataList from './model/CampaignControllerDtoAppDetailAppDetailDataList';
import CampaignControllerDtoAppDetailRequest from './model/CampaignControllerDtoAppDetailRequest';
import CampaignControllerDtoAppDetailResponse from './model/CampaignControllerDtoAppDetailResponse';
import CampaignControllerDtoAppListAppData from './model/CampaignControllerDtoAppListAppData';
import CampaignControllerDtoAppListRequest from './model/CampaignControllerDtoAppListRequest';
import CampaignControllerDtoAppListResponse from './model/CampaignControllerDtoAppListResponse';
import CampaignControllerDtoAppRemoveRequest from './model/CampaignControllerDtoAppRemoveRequest';
import CampaignControllerDtoAppRemoveResponse from './model/CampaignControllerDtoAppRemoveResponse';
import CampaignControllerDtoAppSearchAppSearchData from './model/CampaignControllerDtoAppSearchAppSearchData';
import CampaignControllerDtoAppSearchRequest from './model/CampaignControllerDtoAppSearchRequest';
import CampaignControllerDtoAppSearchResponse from './model/CampaignControllerDtoAppSearchResponse';
import CampaignControllerDtoAppUpdateRequest from './model/CampaignControllerDtoAppUpdateRequest';
import CampaignControllerDtoAppUpdateResponse from './model/CampaignControllerDtoAppUpdateResponse';
import CampaignControllerDtoAppVersionUpdateRequest from './model/CampaignControllerDtoAppVersionUpdateRequest';
import CampaignControllerDtoCampaignDetailCampaignDetailData from './model/CampaignControllerDtoCampaignDetailCampaignDetailData';
import CampaignControllerDtoCampaignDetailRequest from './model/CampaignControllerDtoCampaignDetailRequest';
import CampaignControllerDtoCampaignDetailResponse from './model/CampaignControllerDtoCampaignDetailResponse';
import CampaignControllerDtoCampaignListCampaignData from './model/CampaignControllerDtoCampaignListCampaignData';
import CampaignControllerDtoCampaignListRequest from './model/CampaignControllerDtoCampaignListRequest';
import CampaignControllerDtoCampaignListResponse from './model/CampaignControllerDtoCampaignListResponse';
import CampaignControllerDtoCampaignLockStateRequest from './model/CampaignControllerDtoCampaignLockStateRequest';
import CampaignControllerDtoCampaignRemoveRequest from './model/CampaignControllerDtoCampaignRemoveRequest';
import CampaignControllerDtoCampaignSortRequest from './model/CampaignControllerDtoCampaignSortRequest';
import CampaignControllerDtoCampaignTerminateRequest from './model/CampaignControllerDtoCampaignTerminateRequest';
import CampaignControllerDtoCreateAppRequest from './model/CampaignControllerDtoCreateAppRequest';
import CampaignControllerDtoCreateAppResponse from './model/CampaignControllerDtoCreateAppResponse';
import CampaignControllerDtoPlayStoreSearchRequest from './model/CampaignControllerDtoPlayStoreSearchRequest';
import CampaignControllerDtoPlayStoreSearchResponse from './model/CampaignControllerDtoPlayStoreSearchResponse';
import CampaignControllerDtoResourceUpdateRequest from './model/CampaignControllerDtoResourceUpdateRequest';
import CampaignControllerDtoWhiteListAddRequest from './model/CampaignControllerDtoWhiteListAddRequest';
import CampaignControllerDtoWhiteListRemoveRequest from './model/CampaignControllerDtoWhiteListRemoveRequest';
import CampaignSortData from './model/CampaignSortData';
import CategoryListGnb from './model/CategoryListGnb';
import CategoryListLnb from './model/CategoryListLnb';
import CategoryListSub from './model/CategoryListSub';
import CollaboType from './model/CollaboType';
import CommunityControllerDtoPostAccountSearchRequest from './model/CommunityControllerDtoPostAccountSearchRequest';
import CommunityControllerDtoPostAccountSearchResponse from './model/CommunityControllerDtoPostAccountSearchResponse';
import CommunityControllerDtoPostCreateFromExcelResponse from './model/CommunityControllerDtoPostCreateFromExcelResponse';
import CommunityControllerDtoPostCreateResponse from './model/CommunityControllerDtoPostCreateResponse';
import CommunityControllerDtoPostDetailRequest from './model/CommunityControllerDtoPostDetailRequest';
import CommunityControllerDtoPostDetailResponse from './model/CommunityControllerDtoPostDetailResponse';
import CommunityControllerDtoPostExcelDownloadRequest from './model/CommunityControllerDtoPostExcelDownloadRequest';
import CommunityControllerDtoPostListRequest from './model/CommunityControllerDtoPostListRequest';
import CommunityControllerDtoPostListResponse from './model/CommunityControllerDtoPostListResponse';
import CommunityControllerDtoPostRemoveRequest from './model/CommunityControllerDtoPostRemoveRequest';
import ContentsIndex from './model/ContentsIndex';
import ContentsWalletListData from './model/ContentsWalletListData';
import DashboardAvailableBalanceData from './model/DashboardAvailableBalanceData';
import DashboardControllerDtoGetDashboardDataDurationType from './model/DashboardControllerDtoGetDashboardDataDurationType';
import DashboardControllerDtoGetDashboardDataMiningStatistics from './model/DashboardControllerDtoGetDashboardDataMiningStatistics';
import DashboardControllerDtoGetDashboardDataRequest from './model/DashboardControllerDtoGetDashboardDataRequest';
import DashboardControllerDtoGetDashboardDataResponse from './model/DashboardControllerDtoGetDashboardDataResponse';
import DashboardControllerDtoGetDashboardDataTransactionStatistics from './model/DashboardControllerDtoGetDashboardDataTransactionStatistics';
import DashboardControllerDtoGetDashboardDataUserStatistics from './model/DashboardControllerDtoGetDashboardDataUserStatistics';
import DashboardControllerDtoGetDashboardDataWalletData from './model/DashboardControllerDtoGetDashboardDataWalletData';
import DashboardMiningData from './model/DashboardMiningData';
import DashboardUsageAndDestroyData from './model/DashboardUsageAndDestroyData';
import DepartmentData from './model/DepartmentData';
import DistributionChannel from './model/DistributionChannel';
import EventsControllerDtoBannerListBannerData from './model/EventsControllerDtoBannerListBannerData';
import EventsControllerDtoBannerListImageData from './model/EventsControllerDtoBannerListImageData';
import EventsControllerDtoBannerListRequest from './model/EventsControllerDtoBannerListRequest';
import EventsControllerDtoBannerListResponse from './model/EventsControllerDtoBannerListResponse';
import EventsControllerDtoBannerRemoveRequest from './model/EventsControllerDtoBannerRemoveRequest';
import EventsControllerDtoBannerSortUpdateRequest from './model/EventsControllerDtoBannerSortUpdateRequest';
import EventsControllerDtoDrawItemCreateResponse from './model/EventsControllerDtoDrawItemCreateResponse';
import EventsControllerDtoDrawItemDetailDrawItemRewardDetailData from './model/EventsControllerDtoDrawItemDetailDrawItemRewardDetailData';
import EventsControllerDtoDrawItemDetailImageData from './model/EventsControllerDtoDrawItemDetailImageData';
import EventsControllerDtoDrawItemDetailRequest from './model/EventsControllerDtoDrawItemDetailRequest';
import EventsControllerDtoDrawItemDetailResponse from './model/EventsControllerDtoDrawItemDetailResponse';
import EventsControllerDtoDrawItemListDrawItemInfoData from './model/EventsControllerDtoDrawItemListDrawItemInfoData';
import EventsControllerDtoDrawItemListRequest from './model/EventsControllerDtoDrawItemListRequest';
import EventsControllerDtoDrawItemListResponse from './model/EventsControllerDtoDrawItemListResponse';
import EventsControllerDtoDrawItemLogListDrawItemLogData from './model/EventsControllerDtoDrawItemLogListDrawItemLogData';
import EventsControllerDtoDrawItemLogListRequest from './model/EventsControllerDtoDrawItemLogListRequest';
import EventsControllerDtoDrawItemLogListResponse from './model/EventsControllerDtoDrawItemLogListResponse';
import EventsControllerDtoDrawItemRemoveRequest from './model/EventsControllerDtoDrawItemRemoveRequest';
import EventsControllerDtoEventFreeNftCreateRequest from './model/EventsControllerDtoEventFreeNftCreateRequest';
import EventsControllerDtoEventFreeNftDetailRequest from './model/EventsControllerDtoEventFreeNftDetailRequest';
import EventsControllerDtoEventFreeNftDetailResponse from './model/EventsControllerDtoEventFreeNftDetailResponse';
import EventsControllerDtoEventFreeNftHistoryListEventFreeNftHistoryData from './model/EventsControllerDtoEventFreeNftHistoryListEventFreeNftHistoryData';
import EventsControllerDtoEventFreeNftHistoryListRequest from './model/EventsControllerDtoEventFreeNftHistoryListRequest';
import EventsControllerDtoEventFreeNftHistoryListResponse from './model/EventsControllerDtoEventFreeNftHistoryListResponse';
import EventsControllerDtoEventFreeNftListEventFreeNftData from './model/EventsControllerDtoEventFreeNftListEventFreeNftData';
import EventsControllerDtoEventFreeNftListRequest from './model/EventsControllerDtoEventFreeNftListRequest';
import EventsControllerDtoEventFreeNftListResponse from './model/EventsControllerDtoEventFreeNftListResponse';
import EventsControllerDtoEventFreeNftRemoveRequest from './model/EventsControllerDtoEventFreeNftRemoveRequest';
import EventsControllerDtoEventFreeNftUpdateRequest from './model/EventsControllerDtoEventFreeNftUpdateRequest';
import EventsControllerDtoEventInvitationHistoryListEventInvitationHistoryData from './model/EventsControllerDtoEventInvitationHistoryListEventInvitationHistoryData';
import EventsControllerDtoEventInvitationHistoryListRequest from './model/EventsControllerDtoEventInvitationHistoryListRequest';
import EventsControllerDtoEventInvitationHistoryListResponse from './model/EventsControllerDtoEventInvitationHistoryListResponse';
import EventsControllerDtoEventInvitationInfosCreateRequest from './model/EventsControllerDtoEventInvitationInfosCreateRequest';
import EventsControllerDtoEventInvitationInfosDetailRequest from './model/EventsControllerDtoEventInvitationInfosDetailRequest';
import EventsControllerDtoEventInvitationInfosDetailResponse from './model/EventsControllerDtoEventInvitationInfosDetailResponse';
import EventsControllerDtoEventInvitationInfosListEventInvitationInfosData from './model/EventsControllerDtoEventInvitationInfosListEventInvitationInfosData';
import EventsControllerDtoEventInvitationInfosListRequest from './model/EventsControllerDtoEventInvitationInfosListRequest';
import EventsControllerDtoEventInvitationInfosListResponse from './model/EventsControllerDtoEventInvitationInfosListResponse';
import EventsControllerDtoEventInvitationInfosRemoveRequest from './model/EventsControllerDtoEventInvitationInfosRemoveRequest';
import EventsControllerDtoEventInvitationInfosUpdateRequest from './model/EventsControllerDtoEventInvitationInfosUpdateRequest';
import EventsControllerDtoEventInvitationPartnerCreateRequest from './model/EventsControllerDtoEventInvitationPartnerCreateRequest';
import EventsControllerDtoEventInvitationPartnerDetailEventInvitationPartnerDetailListData from './model/EventsControllerDtoEventInvitationPartnerDetailEventInvitationPartnerDetailListData';
import EventsControllerDtoEventInvitationPartnerDetailRequest from './model/EventsControllerDtoEventInvitationPartnerDetailRequest';
import EventsControllerDtoEventInvitationPartnerDetailResponse from './model/EventsControllerDtoEventInvitationPartnerDetailResponse';
import EventsControllerDtoEventInvitationPartnerListEventInvitationPartnerListData from './model/EventsControllerDtoEventInvitationPartnerListEventInvitationPartnerListData';
import EventsControllerDtoEventInvitationPartnerListRequest from './model/EventsControllerDtoEventInvitationPartnerListRequest';
import EventsControllerDtoEventInvitationPartnerListResponse from './model/EventsControllerDtoEventInvitationPartnerListResponse';
import EventsControllerDtoEventInvitationPartnerRewardListEventInvitationPartnerRewardListData from './model/EventsControllerDtoEventInvitationPartnerRewardListEventInvitationPartnerRewardListData';
import EventsControllerDtoEventInvitationPartnerRewardListRequest from './model/EventsControllerDtoEventInvitationPartnerRewardListRequest';
import EventsControllerDtoEventInvitationPartnerRewardListResponse from './model/EventsControllerDtoEventInvitationPartnerRewardListResponse';
import EventsControllerDtoEventInvitationPartnerUpdateRequest from './model/EventsControllerDtoEventInvitationPartnerUpdateRequest';
import EventsControllerDtoEventInvitationRewardListEventInvitationRewardData from './model/EventsControllerDtoEventInvitationRewardListEventInvitationRewardData';
import EventsControllerDtoEventInvitationRewardListRequest from './model/EventsControllerDtoEventInvitationRewardListRequest';
import EventsControllerDtoEventInvitationRewardListResponse from './model/EventsControllerDtoEventInvitationRewardListResponse';
import EventsControllerDtoEventRaffleHistoryListListData from './model/EventsControllerDtoEventRaffleHistoryListListData';
import EventsControllerDtoEventRaffleHistoryListRequest from './model/EventsControllerDtoEventRaffleHistoryListRequest';
import EventsControllerDtoEventRaffleHistoryListResponse from './model/EventsControllerDtoEventRaffleHistoryListResponse';
import EventsControllerDtoEventStarterPackHistoryListEventStarterPackHistoryData from './model/EventsControllerDtoEventStarterPackHistoryListEventStarterPackHistoryData';
import EventsControllerDtoEventStarterPackHistoryListRequest from './model/EventsControllerDtoEventStarterPackHistoryListRequest';
import EventsControllerDtoEventStarterPackHistoryListResponse from './model/EventsControllerDtoEventStarterPackHistoryListResponse';
import EventsControllerDtoEventStarterPackInfoAddBudgetRequest from './model/EventsControllerDtoEventStarterPackInfoAddBudgetRequest';
import EventsControllerDtoEventStarterPackInfoCreateRequest from './model/EventsControllerDtoEventStarterPackInfoCreateRequest';
import EventsControllerDtoEventStarterPackInfoDepositRequest from './model/EventsControllerDtoEventStarterPackInfoDepositRequest';
import EventsControllerDtoEventStarterPackInfoDetailRequest from './model/EventsControllerDtoEventStarterPackInfoDetailRequest';
import EventsControllerDtoEventStarterPackInfoDetailResponse from './model/EventsControllerDtoEventStarterPackInfoDetailResponse';
import EventsControllerDtoEventStarterPackInfoListEventStarterPackInfoData from './model/EventsControllerDtoEventStarterPackInfoListEventStarterPackInfoData';
import EventsControllerDtoEventStarterPackInfoListRequest from './model/EventsControllerDtoEventStarterPackInfoListRequest';
import EventsControllerDtoEventStarterPackInfoListResponse from './model/EventsControllerDtoEventStarterPackInfoListResponse';
import EventsControllerDtoEventStarterPackInfoRemoveRequest from './model/EventsControllerDtoEventStarterPackInfoRemoveRequest';
import EventsControllerDtoEventStarterPackInfoUpdateRequest from './model/EventsControllerDtoEventStarterPackInfoUpdateRequest';
import EventsControllerDtoNoticeListImageData from './model/EventsControllerDtoNoticeListImageData';
import EventsControllerDtoNoticeListNoticeData from './model/EventsControllerDtoNoticeListNoticeData';
import EventsControllerDtoNoticeListRequest from './model/EventsControllerDtoNoticeListRequest';
import EventsControllerDtoNoticeListResponse from './model/EventsControllerDtoNoticeListResponse';
import EventsControllerDtoNoticeRemoveRequest from './model/EventsControllerDtoNoticeRemoveRequest';
import EventsControllerDtoNoticeSortUpdateRequest from './model/EventsControllerDtoNoticeSortUpdateRequest';
import EventsControllerDtoRaffleInfoRequest from './model/EventsControllerDtoRaffleInfoRequest';
import EventsControllerDtoRaffleInfoResponse from './model/EventsControllerDtoRaffleInfoResponse';
import EventsControllerDtoRaffleListListData from './model/EventsControllerDtoRaffleListListData';
import EventsControllerDtoRaffleListRequest from './model/EventsControllerDtoRaffleListRequest';
import EventsControllerDtoRaffleListResponse from './model/EventsControllerDtoRaffleListResponse';
import EventsControllerDtoRaffleUpsertRequest from './model/EventsControllerDtoRaffleUpsertRequest';
import EvolveLogData from './model/EvolveLogData';
import ExchangeRateData from './model/ExchangeRateData';
import GameControllerDtoConfigItemListConfigItemData from './model/GameControllerDtoConfigItemListConfigItemData';
import GameControllerDtoConfigItemListRequest from './model/GameControllerDtoConfigItemListRequest';
import GameControllerDtoConfigItemListResponse from './model/GameControllerDtoConfigItemListResponse';
import GameControllerDtoGameConfigCreateRequest from './model/GameControllerDtoGameConfigCreateRequest';
import GameControllerDtoGameConfigInfoGameConfigInfoData from './model/GameControllerDtoGameConfigInfoGameConfigInfoData';
import GameControllerDtoGameConfigInfoResponse from './model/GameControllerDtoGameConfigInfoResponse';
import GameControllerDtoGameConfigRemoveRequest from './model/GameControllerDtoGameConfigRemoveRequest';
import GameControllerDtoGameConfigRemoveResponse from './model/GameControllerDtoGameConfigRemoveResponse';
import GameControllerDtoGameConfigUpdateRequest from './model/GameControllerDtoGameConfigUpdateRequest';
import GameControllerDtoGameConfigUpdateResponse from './model/GameControllerDtoGameConfigUpdateResponse';
import GameControllerDtoMaterialConfigCheckResponse from './model/GameControllerDtoMaterialConfigCheckResponse';
import GameControllerDtoMaterialConfigInfoMaterialConfigInfoData from './model/GameControllerDtoMaterialConfigInfoMaterialConfigInfoData';
import GameControllerDtoMaterialConfigInfoResponse from './model/GameControllerDtoMaterialConfigInfoResponse';
import GameType from './model/GameType';
import GemColor from './model/GemColor';
import GemEffect from './model/GemEffect';
import GroupRoleCategoryData from './model/GroupRoleCategoryData';
import GroupRoleUpdateData from './model/GroupRoleUpdateData';
import InventoryControllerDtoItemGroupListItemGroupListData from './model/InventoryControllerDtoItemGroupListItemGroupListData';
import InventoryControllerDtoItemGroupListRequest from './model/InventoryControllerDtoItemGroupListRequest';
import InventoryControllerDtoItemGroupListResponse from './model/InventoryControllerDtoItemGroupListResponse';
import InventoryControllerDtoItemRemoveRequest from './model/InventoryControllerDtoItemRemoveRequest';
import InventoryControllerDtoNftInventoryValidUpdateRequest from './model/InventoryControllerDtoNftInventoryValidUpdateRequest';
import LogControllerDtoAccountHolderChangeLogListAccountHolderChangeLogData from './model/LogControllerDtoAccountHolderChangeLogListAccountHolderChangeLogData';
import LogControllerDtoAccountHolderChangeLogListRequest from './model/LogControllerDtoAccountHolderChangeLogListRequest';
import LogControllerDtoAccountHolderChangeLogListResponse from './model/LogControllerDtoAccountHolderChangeLogListResponse';
import LogControllerDtoAccountLoginLogListAccountLoginLogData from './model/LogControllerDtoAccountLoginLogListAccountLoginLogData';
import LogControllerDtoAccountLoginLogListRequest from './model/LogControllerDtoAccountLoginLogListRequest';
import LogControllerDtoAccountLoginLogListResponse from './model/LogControllerDtoAccountLoginLogListResponse';
import LogControllerDtoAccountSessionLogListAccountSessionLogData from './model/LogControllerDtoAccountSessionLogListAccountSessionLogData';
import LogControllerDtoAccountSessionLogListRequest from './model/LogControllerDtoAccountSessionLogListRequest';
import LogControllerDtoAccountSessionLogListResponse from './model/LogControllerDtoAccountSessionLogListResponse';
import LogControllerDtoBreedLogListBreedLogData from './model/LogControllerDtoBreedLogListBreedLogData';
import LogControllerDtoBreedLogListRequest from './model/LogControllerDtoBreedLogListRequest';
import LogControllerDtoBreedLogListResponse from './model/LogControllerDtoBreedLogListResponse';
import LogControllerDtoCommonSafetyCodeLogListListData from './model/LogControllerDtoCommonSafetyCodeLogListListData';
import LogControllerDtoCommonSafetyCodeLogListRequest from './model/LogControllerDtoCommonSafetyCodeLogListRequest';
import LogControllerDtoCommonSafetyCodeLogListResponse from './model/LogControllerDtoCommonSafetyCodeLogListResponse';
import LogControllerDtoEvolveLogListRequest from './model/LogControllerDtoEvolveLogListRequest';
import LogControllerDtoEvolveLogListResponse from './model/LogControllerDtoEvolveLogListResponse';
import LogControllerDtoGamePlaySessionLogListGamePlaySessionLogData from './model/LogControllerDtoGamePlaySessionLogListGamePlaySessionLogData';
import LogControllerDtoGamePlaySessionLogListRequest from './model/LogControllerDtoGamePlaySessionLogListRequest';
import LogControllerDtoGamePlaySessionLogListResponse from './model/LogControllerDtoGamePlaySessionLogListResponse';
import LogControllerDtoGearMiningLogListGearMiningLogData from './model/LogControllerDtoGearMiningLogListGearMiningLogData';
import LogControllerDtoGearMiningLogListRequest from './model/LogControllerDtoGearMiningLogListRequest';
import LogControllerDtoGearMiningLogListResponse from './model/LogControllerDtoGearMiningLogListResponse';
import LogControllerDtoGemSocketUpdateLogListGemSocketUpdateLogData from './model/LogControllerDtoGemSocketUpdateLogListGemSocketUpdateLogData';
import LogControllerDtoGemSocketUpdateLogListRequest from './model/LogControllerDtoGemSocketUpdateLogListRequest';
import LogControllerDtoGemSocketUpdateLogListResponse from './model/LogControllerDtoGemSocketUpdateLogListResponse';
import LogControllerDtoGoogleStorePurchaseLogListListData from './model/LogControllerDtoGoogleStorePurchaseLogListListData';
import LogControllerDtoGoogleStorePurchaseLogListRequest from './model/LogControllerDtoGoogleStorePurchaseLogListRequest';
import LogControllerDtoGoogleStorePurchaseLogListResponse from './model/LogControllerDtoGoogleStorePurchaseLogListResponse';
import LogControllerDtoInventoryTransactionLogListInventoryTransactionLogData from './model/LogControllerDtoInventoryTransactionLogListInventoryTransactionLogData';
import LogControllerDtoInventoryTransactionLogListRequest from './model/LogControllerDtoInventoryTransactionLogListRequest';
import LogControllerDtoInventoryTransactionLogListResponse from './model/LogControllerDtoInventoryTransactionLogListResponse';
import LogControllerDtoItemBoxOpenLogListListData from './model/LogControllerDtoItemBoxOpenLogListListData';
import LogControllerDtoItemBoxOpenLogListRequest from './model/LogControllerDtoItemBoxOpenLogListRequest';
import LogControllerDtoItemBoxOpenLogListResponse from './model/LogControllerDtoItemBoxOpenLogListResponse';
import LogControllerDtoItemShopPurchaseLogListListData from './model/LogControllerDtoItemShopPurchaseLogListListData';
import LogControllerDtoItemShopPurchaseLogListRequest from './model/LogControllerDtoItemShopPurchaseLogListRequest';
import LogControllerDtoItemShopPurchaseLogListResponse from './model/LogControllerDtoItemShopPurchaseLogListResponse';
import LogControllerDtoItemTransactionLogListItemTransactionLogData from './model/LogControllerDtoItemTransactionLogListItemTransactionLogData';
import LogControllerDtoItemTransactionLogListRequest from './model/LogControllerDtoItemTransactionLogListRequest';
import LogControllerDtoItemTransactionLogListResponse from './model/LogControllerDtoItemTransactionLogListResponse';
import LogControllerDtoLevelUpLogListLevelUpLogData from './model/LogControllerDtoLevelUpLogListLevelUpLogData';
import LogControllerDtoLevelUpLogListRequest from './model/LogControllerDtoLevelUpLogListRequest';
import LogControllerDtoLevelUpLogListResponse from './model/LogControllerDtoLevelUpLogListResponse';
import LogControllerDtoMarketCarBoxTransactionLogListMarketCarBoxTransactionLogData from './model/LogControllerDtoMarketCarBoxTransactionLogListMarketCarBoxTransactionLogData';
import LogControllerDtoMarketCarBoxTransactionLogListRequest from './model/LogControllerDtoMarketCarBoxTransactionLogListRequest';
import LogControllerDtoMarketCarBoxTransactionLogListResponse from './model/LogControllerDtoMarketCarBoxTransactionLogListResponse';
import LogControllerDtoMarketCarTransactionLogListMarketCarTransactionLogData from './model/LogControllerDtoMarketCarTransactionLogListMarketCarTransactionLogData';
import LogControllerDtoMarketCarTransactionLogListRequest from './model/LogControllerDtoMarketCarTransactionLogListRequest';
import LogControllerDtoMarketCarTransactionLogListResponse from './model/LogControllerDtoMarketCarTransactionLogListResponse';
import LogControllerDtoMarketGemTransactionLogListRequest from './model/LogControllerDtoMarketGemTransactionLogListRequest';
import LogControllerDtoMarketGemTransactionLogListResponse from './model/LogControllerDtoMarketGemTransactionLogListResponse';
import LogControllerDtoMarketItemTransactionLogListRequest from './model/LogControllerDtoMarketItemTransactionLogListRequest';
import LogControllerDtoMarketItemTransactionLogListResponse from './model/LogControllerDtoMarketItemTransactionLogListResponse';
import LogControllerDtoMarketPilotTransactionLogListMarketPilotTransactionLogData from './model/LogControllerDtoMarketPilotTransactionLogListMarketPilotTransactionLogData';
import LogControllerDtoMarketPilotTransactionLogListRequest from './model/LogControllerDtoMarketPilotTransactionLogListRequest';
import LogControllerDtoMarketPilotTransactionLogListResponse from './model/LogControllerDtoMarketPilotTransactionLogListResponse';
import LogControllerDtoMissionFreeLogListMissionFreeLogData from './model/LogControllerDtoMissionFreeLogListMissionFreeLogData';
import LogControllerDtoMissionFreeLogListRequest from './model/LogControllerDtoMissionFreeLogListRequest';
import LogControllerDtoMissionFreeLogListResponse from './model/LogControllerDtoMissionFreeLogListResponse';
import LogControllerDtoNftDisassembleLogListNftDisassembleLogListData from './model/LogControllerDtoNftDisassembleLogListNftDisassembleLogListData';
import LogControllerDtoNftDisassembleLogListRequest from './model/LogControllerDtoNftDisassembleLogListRequest';
import LogControllerDtoNftDisassembleLogListResponse from './model/LogControllerDtoNftDisassembleLogListResponse';
import LogControllerDtoNftRepairLogListNftRepairLogData from './model/LogControllerDtoNftRepairLogListNftRepairLogData';
import LogControllerDtoNftRepairLogListRequest from './model/LogControllerDtoNftRepairLogListRequest';
import LogControllerDtoNftRepairLogListResponse from './model/LogControllerDtoNftRepairLogListResponse';
import LogControllerDtoNftRestoreLogListNftRestoreLogData from './model/LogControllerDtoNftRestoreLogListNftRestoreLogData';
import LogControllerDtoNftRestoreLogListRequest from './model/LogControllerDtoNftRestoreLogListRequest';
import LogControllerDtoNftRestoreLogListResponse from './model/LogControllerDtoNftRestoreLogListResponse';
import LogControllerDtoNftStoredPowersLogListNftStoredPowersLogListData from './model/LogControllerDtoNftStoredPowersLogListNftStoredPowersLogListData';
import LogControllerDtoNftStoredPowersLogListRequest from './model/LogControllerDtoNftStoredPowersLogListRequest';
import LogControllerDtoNftStoredPowersLogListResponse from './model/LogControllerDtoNftStoredPowersLogListResponse';
import LogControllerDtoNftTransactionLogListNftTransactionLogData from './model/LogControllerDtoNftTransactionLogListNftTransactionLogData';
import LogControllerDtoNftTransactionLogListRequest from './model/LogControllerDtoNftTransactionLogListRequest';
import LogControllerDtoNftTransactionLogListResponse from './model/LogControllerDtoNftTransactionLogListResponse';
import LogControllerDtoNicknameChangeLogListNicknameChangeLogData from './model/LogControllerDtoNicknameChangeLogListNicknameChangeLogData';
import LogControllerDtoNicknameChangeLogListRequest from './model/LogControllerDtoNicknameChangeLogListRequest';
import LogControllerDtoNicknameChangeLogListResponse from './model/LogControllerDtoNicknameChangeLogListResponse';
import LogControllerDtoPilotDisassembleLogListPilotDisassembleLogData from './model/LogControllerDtoPilotDisassembleLogListPilotDisassembleLogData';
import LogControllerDtoPilotDisassembleLogListRequest from './model/LogControllerDtoPilotDisassembleLogListRequest';
import LogControllerDtoPilotDisassembleLogListResponse from './model/LogControllerDtoPilotDisassembleLogListResponse';
import LogControllerDtoPilotEquipLogListPilotEquipLogData from './model/LogControllerDtoPilotEquipLogListPilotEquipLogData';
import LogControllerDtoPilotEquipLogListRequest from './model/LogControllerDtoPilotEquipLogListRequest';
import LogControllerDtoPilotEquipLogListResponse from './model/LogControllerDtoPilotEquipLogListResponse';
import LogControllerDtoPilotPromotionLogListPilotPromotionLogData from './model/LogControllerDtoPilotPromotionLogListPilotPromotionLogData';
import LogControllerDtoPilotPromotionLogListRequest from './model/LogControllerDtoPilotPromotionLogListRequest';
import LogControllerDtoPilotPromotionLogListResponse from './model/LogControllerDtoPilotPromotionLogListResponse';
import LogControllerDtoPilotSkillChangeLogListPilotSkillChangeLogData from './model/LogControllerDtoPilotSkillChangeLogListPilotSkillChangeLogData';
import LogControllerDtoPilotSkillChangeLogListRequest from './model/LogControllerDtoPilotSkillChangeLogListRequest';
import LogControllerDtoPilotSkillChangeLogListResponse from './model/LogControllerDtoPilotSkillChangeLogListResponse';
import LogControllerDtoPowerChargeLogListPowerChargeLogData from './model/LogControllerDtoPowerChargeLogListPowerChargeLogData';
import LogControllerDtoPowerChargeLogListRequest from './model/LogControllerDtoPowerChargeLogListRequest';
import LogControllerDtoPowerChargeLogListResponse from './model/LogControllerDtoPowerChargeLogListResponse';
import LogControllerDtoResetStatsLogListRequest from './model/LogControllerDtoResetStatsLogListRequest';
import LogControllerDtoResetStatsLogListResetStatsLogData from './model/LogControllerDtoResetStatsLogListResetStatsLogData';
import LogControllerDtoResetStatsLogListResponse from './model/LogControllerDtoResetStatsLogListResponse';
import LogControllerDtoRollRandomGemSocketsLogListRequest from './model/LogControllerDtoRollRandomGemSocketsLogListRequest';
import LogControllerDtoRollRandomGemSocketsLogListResponse from './model/LogControllerDtoRollRandomGemSocketsLogListResponse';
import LogControllerDtoRollRandomGemSocketsLogListRollRandomGemSocketsLogData from './model/LogControllerDtoRollRandomGemSocketsLogListRollRandomGemSocketsLogData';
import LogControllerDtoSpecialBoxLogListRequest from './model/LogControllerDtoSpecialBoxLogListRequest';
import LogControllerDtoSpecialBoxLogListResponse from './model/LogControllerDtoSpecialBoxLogListResponse';
import LogControllerDtoSpecialBoxLogListSpecialBoxLogData from './model/LogControllerDtoSpecialBoxLogListSpecialBoxLogData';
import LogControllerDtoTransactionAttemptLogListRequest from './model/LogControllerDtoTransactionAttemptLogListRequest';
import LogControllerDtoTransactionAttemptLogListResponse from './model/LogControllerDtoTransactionAttemptLogListResponse';
import LogControllerDtoTransactionAttemptLogListTransactionAttemptLogListData from './model/LogControllerDtoTransactionAttemptLogListTransactionAttemptLogListData';
import LogControllerDtoWalletConnectionLogListRequest from './model/LogControllerDtoWalletConnectionLogListRequest';
import LogControllerDtoWalletConnectionLogListResponse from './model/LogControllerDtoWalletConnectionLogListResponse';
import LogControllerDtoWalletConnectionLogListWalletConnectionLogListData from './model/LogControllerDtoWalletConnectionLogListWalletConnectionLogListData';
import LogControllerDtoWalletTransactionLogListRequest from './model/LogControllerDtoWalletTransactionLogListRequest';
import LogControllerDtoWalletTransactionLogListResponse from './model/LogControllerDtoWalletTransactionLogListResponse';
import LogControllerDtoWalletTransactionLogListWalletTransactionLogData from './model/LogControllerDtoWalletTransactionLogListWalletTransactionLogData';
import ManagerAccountControllerDtoCategoryListResponse from './model/ManagerAccountControllerDtoCategoryListResponse';
import ManagerAccountControllerDtoFindPasswordRequest from './model/ManagerAccountControllerDtoFindPasswordRequest';
import ManagerAccountControllerDtoLoginInfoResponse from './model/ManagerAccountControllerDtoLoginInfoResponse';
import ManagerAccountControllerDtoLoginRequest from './model/ManagerAccountControllerDtoLoginRequest';
import ManagerAccountControllerDtoLoginResponse from './model/ManagerAccountControllerDtoLoginResponse';
import ManagerAccountControllerDtoLoginTwoFaAuthRequest from './model/ManagerAccountControllerDtoLoginTwoFaAuthRequest';
import ManagerAccountControllerDtoLoginTwoFaAuthResponse from './model/ManagerAccountControllerDtoLoginTwoFaAuthResponse';
import ManagerAccountControllerDtoMyInfoResponse from './model/ManagerAccountControllerDtoMyInfoResponse';
import ManagerAccountControllerDtoMyNameChangeRequest from './model/ManagerAccountControllerDtoMyNameChangeRequest';
import ManagerAccountControllerDtoMyNameChangeResponse from './model/ManagerAccountControllerDtoMyNameChangeResponse';
import ManagerAccountControllerDtoMyPasswordChangeRequest from './model/ManagerAccountControllerDtoMyPasswordChangeRequest';
import ManagerAccountControllerDtoMyRemoveTwoFactorRequest from './model/ManagerAccountControllerDtoMyRemoveTwoFactorRequest';
import ManagerAccountControllerDtoNotificationListResponse from './model/ManagerAccountControllerDtoNotificationListResponse';
import ManagerAccountControllerDtoNotificationTokenCreateRequest from './model/ManagerAccountControllerDtoNotificationTokenCreateRequest';
import ManagerAccountControllerDtoNotificationsMarkingAsReadRequest from './model/ManagerAccountControllerDtoNotificationsMarkingAsReadRequest';
import ManagerAccountControllerDtoNotificationsRemoveRequest from './model/ManagerAccountControllerDtoNotificationsRemoveRequest';
import ManagerControllerDtoAuthorizationGroupListResponse from './model/ManagerControllerDtoAuthorizationGroupListResponse';
import ManagerControllerDtoCreateAccountRequest from './model/ManagerControllerDtoCreateAccountRequest';
import ManagerControllerDtoCreateAccountResponse from './model/ManagerControllerDtoCreateAccountResponse';
import ManagerControllerDtoDepartmentListResponse from './model/ManagerControllerDtoDepartmentListResponse';
import ManagerControllerDtoEmailCheckRequest from './model/ManagerControllerDtoEmailCheckRequest';
import ManagerControllerDtoEmailCheckResponse from './model/ManagerControllerDtoEmailCheckResponse';
import ManagerControllerDtoManagerInfoUpdateRequest from './model/ManagerControllerDtoManagerInfoUpdateRequest';
import ManagerControllerDtoManagerListRequest from './model/ManagerControllerDtoManagerListRequest';
import ManagerControllerDtoManagerListResponse from './model/ManagerControllerDtoManagerListResponse';
import ManagerControllerDtoManagerLoginLogListRequest from './model/ManagerControllerDtoManagerLoginLogListRequest';
import ManagerControllerDtoManagerLoginLogListResponse from './model/ManagerControllerDtoManagerLoginLogListResponse';
import ManagerControllerDtoManagerSecedeRequest from './model/ManagerControllerDtoManagerSecedeRequest';
import ManagerControllerDtoManagerTerminateSessionRequest from './model/ManagerControllerDtoManagerTerminateSessionRequest';
import ManagerControllerDtoManagerTwoFactorLogListRequest from './model/ManagerControllerDtoManagerTwoFactorLogListRequest';
import ManagerControllerDtoManagerTwoFactorLogListResponse from './model/ManagerControllerDtoManagerTwoFactorLogListResponse';
import ManagerControllerDtoManagerViewRequest from './model/ManagerControllerDtoManagerViewRequest';
import ManagerControllerDtoManagerViewResponse from './model/ManagerControllerDtoManagerViewResponse';
import ManagerControllerDtoManagerWorkedLogListRequest from './model/ManagerControllerDtoManagerWorkedLogListRequest';
import ManagerControllerDtoManagerWorkedLogListResponse from './model/ManagerControllerDtoManagerWorkedLogListResponse';
import ManagerControllerDtoRemoveTwoFactorRequest from './model/ManagerControllerDtoRemoveTwoFactorRequest';
import ManagerControllerDtoRndChangePasswordRequest from './model/ManagerControllerDtoRndChangePasswordRequest';
import ManagerData from './model/ManagerData';
import ManagerLoginLogData from './model/ManagerLoginLogData';
import ManagerTwoFactorLogData from './model/ManagerTwoFactorLogData';
import ManagerWorkedLogData from './model/ManagerWorkedLogData';
import MarketGoogleStoreProductInfoRequest from './model/MarketGoogleStoreProductInfoRequest';
import MarketGoogleStoreProductInfoResponse from './model/MarketGoogleStoreProductInfoResponse';
import MarketGoogleStoreProductListListData from './model/MarketGoogleStoreProductListListData';
import MarketGoogleStoreProductListRequest from './model/MarketGoogleStoreProductListRequest';
import MarketGoogleStoreProductListResponse from './model/MarketGoogleStoreProductListResponse';
import MarketGoogleStoreProductSortUpdateRequest from './model/MarketGoogleStoreProductSortUpdateRequest';
import MarketGoogleStoreProductUpsertRequest from './model/MarketGoogleStoreProductUpsertRequest';
import MarketItemShopInfoRequest from './model/MarketItemShopInfoRequest';
import MarketItemShopInfoResponse from './model/MarketItemShopInfoResponse';
import MarketItemShopListListData from './model/MarketItemShopListListData';
import MarketItemShopListRequest from './model/MarketItemShopListRequest';
import MarketItemShopListResponse from './model/MarketItemShopListResponse';
import MarketItemShopSortUpdateRequest from './model/MarketItemShopSortUpdateRequest';
import MarketItemShopUpsertRequest from './model/MarketItemShopUpsertRequest';
import MarketItemTransactionLogData from './model/MarketItemTransactionLogData';
import MarketStatus from './model/MarketStatus';
import Material from './model/Material';
import MaterialProperty from './model/MaterialProperty';
import MaterialType from './model/MaterialType';
import MissionControllerDtoBasicAccountInfoListBasicAccountInfoListData from './model/MissionControllerDtoBasicAccountInfoListBasicAccountInfoListData';
import MissionControllerDtoBasicAccountInfoListRequest from './model/MissionControllerDtoBasicAccountInfoListRequest';
import MissionControllerDtoBasicAccountInfoListResponse from './model/MissionControllerDtoBasicAccountInfoListResponse';
import MissionControllerDtoBasicAccountPointLogListBasicAccountPointLogListData from './model/MissionControllerDtoBasicAccountPointLogListBasicAccountPointLogListData';
import MissionControllerDtoBasicAccountPointLogListRequest from './model/MissionControllerDtoBasicAccountPointLogListRequest';
import MissionControllerDtoBasicAccountPointLogListResponse from './model/MissionControllerDtoBasicAccountPointLogListResponse';
import MissionControllerDtoBasicGradeRewardLogListBasicGradeRewardLogListData from './model/MissionControllerDtoBasicGradeRewardLogListBasicGradeRewardLogListData';
import MissionControllerDtoBasicGradeRewardLogListRequest from './model/MissionControllerDtoBasicGradeRewardLogListRequest';
import MissionControllerDtoBasicGradeRewardLogListResponse from './model/MissionControllerDtoBasicGradeRewardLogListResponse';
import MissionControllerDtoBasicInvitedUsersListBasicInvitedUsersListData from './model/MissionControllerDtoBasicInvitedUsersListBasicInvitedUsersListData';
import MissionControllerDtoBasicInvitedUsersListRequest from './model/MissionControllerDtoBasicInvitedUsersListRequest';
import MissionControllerDtoBasicInvitedUsersListResponse from './model/MissionControllerDtoBasicInvitedUsersListResponse';
import MissionControllerDtoMissionFreeInfoCreateRequest from './model/MissionControllerDtoMissionFreeInfoCreateRequest';
import MissionControllerDtoMissionFreeInfoDetailRequest from './model/MissionControllerDtoMissionFreeInfoDetailRequest';
import MissionControllerDtoMissionFreeInfoDetailResponse from './model/MissionControllerDtoMissionFreeInfoDetailResponse';
import MissionControllerDtoMissionFreeInfoListBasicMissionFreeInfo from './model/MissionControllerDtoMissionFreeInfoListBasicMissionFreeInfo';
import MissionControllerDtoMissionFreeInfoListRequest from './model/MissionControllerDtoMissionFreeInfoListRequest';
import MissionControllerDtoMissionFreeInfoListResponse from './model/MissionControllerDtoMissionFreeInfoListResponse';
import MissionControllerDtoMissionFreeInfoUpdateRequest from './model/MissionControllerDtoMissionFreeInfoUpdateRequest';
import MnGnbData from './model/MnGnbData';
import MnLnbData from './model/MnLnbData';
import MnSubLnbData from './model/MnSubLnbData';
import MonitoringControllerDtoGearNftListGearNftData from './model/MonitoringControllerDtoGearNftListGearNftData';
import MonitoringControllerDtoGearNftListRequest from './model/MonitoringControllerDtoGearNftListRequest';
import MonitoringControllerDtoGearNftListResponse from './model/MonitoringControllerDtoGearNftListResponse';
import MonitoringControllerDtoNftBoxListNftBoxData from './model/MonitoringControllerDtoNftBoxListNftBoxData';
import MonitoringControllerDtoNftBoxListRequest from './model/MonitoringControllerDtoNftBoxListRequest';
import MonitoringControllerDtoNftBoxListResponse from './model/MonitoringControllerDtoNftBoxListResponse';
import MonitoringControllerDtoNftCarListNftCarData from './model/MonitoringControllerDtoNftCarListNftCarData';
import MonitoringControllerDtoNftCarListRequest from './model/MonitoringControllerDtoNftCarListRequest';
import MonitoringControllerDtoNftCarListResponse from './model/MonitoringControllerDtoNftCarListResponse';
import MonitoringControllerDtoPilotNftListRequest from './model/MonitoringControllerDtoPilotNftListRequest';
import MonitoringControllerDtoPilotNftListResponse from './model/MonitoringControllerDtoPilotNftListResponse';
import MonitoringControllerDtoWalletListRequest from './model/MonitoringControllerDtoWalletListRequest';
import MonitoringControllerDtoWalletListResponse from './model/MonitoringControllerDtoWalletListResponse';
import MonitoringControllerDtoWalletListWalletData from './model/MonitoringControllerDtoWalletListWalletData';
import NftBoxGrade from './model/NftBoxGrade';
import NftBoxType from './model/NftBoxType';
import NftControllerDtoNftGenerateCreateRequest from './model/NftControllerDtoNftGenerateCreateRequest';
import NftControllerDtoNftGenerateDetailRequest from './model/NftControllerDtoNftGenerateDetailRequest';
import NftControllerDtoNftGenerateDetailResponse from './model/NftControllerDtoNftGenerateDetailResponse';
import NftControllerDtoNftGenerateItemCreateRequest from './model/NftControllerDtoNftGenerateItemCreateRequest';
import NftControllerDtoNftGenerateItemListRequest from './model/NftControllerDtoNftGenerateItemListRequest';
import NftControllerDtoNftGenerateItemListResponse from './model/NftControllerDtoNftGenerateItemListResponse';
import NftControllerDtoNftGenerateItemRemoveRequest from './model/NftControllerDtoNftGenerateItemRemoveRequest';
import NftControllerDtoNftGenerateListRequest from './model/NftControllerDtoNftGenerateListRequest';
import NftControllerDtoNftGenerateListResponse from './model/NftControllerDtoNftGenerateListResponse';
import NftControllerDtoNftGenerateRemoveRequest from './model/NftControllerDtoNftGenerateRemoveRequest';
import NftControllerDtoNftGenerateStartCreatingRequest from './model/NftControllerDtoNftGenerateStartCreatingRequest';
import NftGenerateData from './model/NftGenerateData';
import NftGenerateModel from './model/NftGenerateModel';
import NftGeneratePublicData from './model/NftGeneratePublicData';
import NftGenerateType from './model/NftGenerateType';
import NftGeneratorControllerDtoAddNftKeyIndexRequest from './model/NftGeneratorControllerDtoAddNftKeyIndexRequest';
import NftGeneratorControllerDtoAddNftUidIndexRequest from './model/NftGeneratorControllerDtoAddNftUidIndexRequest';
import NftGeneratorControllerDtoNftBurnRequest from './model/NftGeneratorControllerDtoNftBurnRequest';
import NftGeneratorControllerDtoNftGenerateRequest from './model/NftGeneratorControllerDtoNftGenerateRequest';
import NftGeneratorControllerDtoNftGenerateResponse from './model/NftGeneratorControllerDtoNftGenerateResponse';
import NftGeneratorControllerDtoNftImageGenerateRequest from './model/NftGeneratorControllerDtoNftImageGenerateRequest';
import NftGeneratorControllerDtoNftImageGenerateResponse from './model/NftGeneratorControllerDtoNftImageGenerateResponse';
import NftGeneratorControllerDtoNftImageRecoveryRequest from './model/NftGeneratorControllerDtoNftImageRecoveryRequest';
import NftGeneratorControllerDtoNftImageRecoveryResponse from './model/NftGeneratorControllerDtoNftImageRecoveryResponse';
import NftGeneratorControllerDtoRemoveNftKeyIndexRequest from './model/NftGeneratorControllerDtoRemoveNftKeyIndexRequest';
import NftGeneratorControllerDtoRemoveNftUidIndexRequest from './model/NftGeneratorControllerDtoRemoveNftUidIndexRequest';
import NftGrade from './model/NftGrade';
import NftImageGenerateModel from './model/NftImageGenerateModel';
import NftLevelUpInfoData from './model/NftLevelUpInfoData';
import NftProperty from './model/NftProperty';
import NftSeal from './model/NftSeal';
import NftType from './model/NftType';
import NotificationData from './model/NotificationData';
import PerplayStatisticsControllerDtoItemRequest from './model/PerplayStatisticsControllerDtoItemRequest';
import PerplayStatisticsControllerDtoItemResponse from './model/PerplayStatisticsControllerDtoItemResponse';
import PerplayStatisticsControllerDtoItemStatisticsItemData from './model/PerplayStatisticsControllerDtoItemStatisticsItemData';
import PerplayStatisticsControllerDtoMarketGemRequest from './model/PerplayStatisticsControllerDtoMarketGemRequest';
import PerplayStatisticsControllerDtoMarketGemResponse from './model/PerplayStatisticsControllerDtoMarketGemResponse';
import PerplayStatisticsControllerDtoMarketGemStatisticsMarketData from './model/PerplayStatisticsControllerDtoMarketGemStatisticsMarketData';
import PerplayStatisticsControllerDtoMarketItemRequest from './model/PerplayStatisticsControllerDtoMarketItemRequest';
import PerplayStatisticsControllerDtoMarketItemResponse from './model/PerplayStatisticsControllerDtoMarketItemResponse';
import PerplayStatisticsControllerDtoMarketItemStatisticsMarketData from './model/PerplayStatisticsControllerDtoMarketItemStatisticsMarketData';
import PerplayStatisticsControllerDtoMarketVehicleBoxRequest from './model/PerplayStatisticsControllerDtoMarketVehicleBoxRequest';
import PerplayStatisticsControllerDtoMarketVehicleBoxResponse from './model/PerplayStatisticsControllerDtoMarketVehicleBoxResponse';
import PerplayStatisticsControllerDtoMarketVehicleBoxStatisticsMarketData from './model/PerplayStatisticsControllerDtoMarketVehicleBoxStatisticsMarketData';
import PerplayStatisticsControllerDtoMarketVehicleRequest from './model/PerplayStatisticsControllerDtoMarketVehicleRequest';
import PerplayStatisticsControllerDtoMarketVehicleResponse from './model/PerplayStatisticsControllerDtoMarketVehicleResponse';
import PerplayStatisticsControllerDtoMarketVehicleStatisticsMarketData from './model/PerplayStatisticsControllerDtoMarketVehicleStatisticsMarketData';
import PerplayStatisticsControllerDtoNftBoxRequest from './model/PerplayStatisticsControllerDtoNftBoxRequest';
import PerplayStatisticsControllerDtoNftBoxResponse from './model/PerplayStatisticsControllerDtoNftBoxResponse';
import PerplayStatisticsControllerDtoNftBoxStatisticsNftBoxData from './model/PerplayStatisticsControllerDtoNftBoxStatisticsNftBoxData';
import PerplayStatisticsControllerDtoNftCarRequest from './model/PerplayStatisticsControllerDtoNftCarRequest';
import PerplayStatisticsControllerDtoNftCarResponse from './model/PerplayStatisticsControllerDtoNftCarResponse';
import PerplayStatisticsControllerDtoNftCarStatisticsNftCarData from './model/PerplayStatisticsControllerDtoNftCarStatisticsNftCarData';
import PerplayStatisticsControllerDtoNftLevelStatRequest from './model/PerplayStatisticsControllerDtoNftLevelStatRequest';
import PerplayStatisticsControllerDtoNftLevelStatResponse from './model/PerplayStatisticsControllerDtoNftLevelStatResponse';
import PerplayStatisticsControllerDtoNftLevelStatStatisticsNftLevelStatData from './model/PerplayStatisticsControllerDtoNftLevelStatStatisticsNftLevelStatData';
import PerplayStatisticsControllerDtoNftLevelStatTimeSeriesData from './model/PerplayStatisticsControllerDtoNftLevelStatTimeSeriesData';
import PerplayStatisticsControllerDtoTokenRequest from './model/PerplayStatisticsControllerDtoTokenRequest';
import PerplayStatisticsControllerDtoTokenResponse from './model/PerplayStatisticsControllerDtoTokenResponse';
import PerplayStatisticsControllerDtoTokenStatisticsTokenData from './model/PerplayStatisticsControllerDtoTokenStatisticsTokenData';
import PerplayStatisticsControllerDtoTokenStatisticsTokenGraphData from './model/PerplayStatisticsControllerDtoTokenStatisticsTokenGraphData';
import PerplayStatisticsControllerDtoUserRequest from './model/PerplayStatisticsControllerDtoUserRequest';
import PerplayStatisticsControllerDtoUserResponse from './model/PerplayStatisticsControllerDtoUserResponse';
import PerplayStatisticsControllerDtoUserStatisticsUserData from './model/PerplayStatisticsControllerDtoUserStatisticsUserData';
import PilotMetadata from './model/PilotMetadata';
import PilotPilotRarity from './model/PilotPilotRarity';
import PilotPilotStatType from './model/PilotPilotStatType';
import PostCreateFailData from './model/PostCreateFailData';
import PostData from './model/PostData';
import PostItemData from './model/PostItemData';
import PostUserData from './model/PostUserData';
import RankControllerDtoRankDetailSettingListListData from './model/RankControllerDtoRankDetailSettingListListData';
import RankControllerDtoRankDetailSettingListResponse from './model/RankControllerDtoRankDetailSettingListResponse';
import RankControllerDtoRankDetailSettingUpdateRequest from './model/RankControllerDtoRankDetailSettingUpdateRequest';
import RankControllerDtoRankDetailSettingUpdateResponse from './model/RankControllerDtoRankDetailSettingUpdateResponse';
import ReferralCodeControllerDtoReferralCodeGenerateRequest from './model/ReferralCodeControllerDtoReferralCodeGenerateRequest';
import ReferralCodeControllerDtoReferralCodeGenerateResponse from './model/ReferralCodeControllerDtoReferralCodeGenerateResponse';
import ResourceData from './model/ResourceData';
import SettlementControllerDtoDoSettlementRequest from './model/SettlementControllerDtoDoSettlementRequest';
import SettlementControllerDtoDoSettlementRequiredTransaction from './model/SettlementControllerDtoDoSettlementRequiredTransaction';
import SettlementControllerDtoDoSettlementResponse from './model/SettlementControllerDtoDoSettlementResponse';
import SettlementControllerDtoListSettlementDailySettlement from './model/SettlementControllerDtoListSettlementDailySettlement';
import SettlementControllerDtoListSettlementRequest from './model/SettlementControllerDtoListSettlementRequest';
import SettlementControllerDtoListSettlementResponse from './model/SettlementControllerDtoListSettlementResponse';
import SettlementControllerDtoListSettlementType from './model/SettlementControllerDtoListSettlementType';
import SysMaintenanceData from './model/SysMaintenanceData';
import SystemControllerDtoApiRoleDeleteRequest from './model/SystemControllerDtoApiRoleDeleteRequest';
import SystemControllerDtoApiRoleListRequest from './model/SystemControllerDtoApiRoleListRequest';
import SystemControllerDtoApiRoleListResponse from './model/SystemControllerDtoApiRoleListResponse';
import SystemControllerDtoApiRoleUpdateRequest from './model/SystemControllerDtoApiRoleUpdateRequest';
import SystemControllerDtoFileListRequest from './model/SystemControllerDtoFileListRequest';
import SystemControllerDtoFileListResponse from './model/SystemControllerDtoFileListResponse';
import SystemControllerDtoFolderListRequest from './model/SystemControllerDtoFolderListRequest';
import SystemControllerDtoFolderListResponse from './model/SystemControllerDtoFolderListResponse';
import SystemControllerDtoGoogleStoreProductImageUpdateRequest from './model/SystemControllerDtoGoogleStoreProductImageUpdateRequest';
import SystemControllerDtoGroupRoleCategoryListRequest from './model/SystemControllerDtoGroupRoleCategoryListRequest';
import SystemControllerDtoGroupRoleCategoryListResponse from './model/SystemControllerDtoGroupRoleCategoryListResponse';
import SystemControllerDtoGroupRoleUpdateRequest from './model/SystemControllerDtoGroupRoleUpdateRequest';
import SystemControllerDtoMnGnbDetailRequest from './model/SystemControllerDtoMnGnbDetailRequest';
import SystemControllerDtoMnGnbDetailResponse from './model/SystemControllerDtoMnGnbDetailResponse';
import SystemControllerDtoMnGnbListResponse from './model/SystemControllerDtoMnGnbListResponse';
import SystemControllerDtoMnGnbUploadRequest from './model/SystemControllerDtoMnGnbUploadRequest';
import SystemControllerDtoMnLnbDetailRequest from './model/SystemControllerDtoMnLnbDetailRequest';
import SystemControllerDtoMnLnbDetailResponse from './model/SystemControllerDtoMnLnbDetailResponse';
import SystemControllerDtoMnLnbListRequest from './model/SystemControllerDtoMnLnbListRequest';
import SystemControllerDtoMnLnbListResponse from './model/SystemControllerDtoMnLnbListResponse';
import SystemControllerDtoMnLnbUploadRequest from './model/SystemControllerDtoMnLnbUploadRequest';
import SystemControllerDtoMnSubLnbDetailRequest from './model/SystemControllerDtoMnSubLnbDetailRequest';
import SystemControllerDtoMnSubLnbDetailResponse from './model/SystemControllerDtoMnSubLnbDetailResponse';
import SystemControllerDtoMnSubLnbListRequest from './model/SystemControllerDtoMnSubLnbListRequest';
import SystemControllerDtoMnSubLnbListResponse from './model/SystemControllerDtoMnSubLnbListResponse';
import SystemControllerDtoMnSubLnbUploadRequest from './model/SystemControllerDtoMnSubLnbUploadRequest';
import SystemControllerDtoSysMaintenanceCreateRequest from './model/SystemControllerDtoSysMaintenanceCreateRequest';
import SystemControllerDtoSysMaintenanceInfoRequest from './model/SystemControllerDtoSysMaintenanceInfoRequest';
import SystemControllerDtoSysMaintenanceInfoResponse from './model/SystemControllerDtoSysMaintenanceInfoResponse';
import SystemControllerDtoSysMaintenanceListRequest from './model/SystemControllerDtoSysMaintenanceListRequest';
import SystemControllerDtoSysMaintenanceListResponse from './model/SystemControllerDtoSysMaintenanceListResponse';
import SystemControllerDtoSysMaintenanceRemoveRequest from './model/SystemControllerDtoSysMaintenanceRemoveRequest';
import SystemControllerDtoSysMaintenanceUpdateRequest from './model/SystemControllerDtoSysMaintenanceUpdateRequest';
import TokenType from './model/TokenType';
import VersionResponse from './model/VersionResponse';
import WalletControllerDtoContentsWalletListResponse from './model/WalletControllerDtoContentsWalletListResponse';
import WalletControllerDtoDashboardAvailableBalanceRequest from './model/WalletControllerDtoDashboardAvailableBalanceRequest';
import WalletControllerDtoDashboardAvailableBalanceResponse from './model/WalletControllerDtoDashboardAvailableBalanceResponse';
import WalletControllerDtoDashboardMiningRequest from './model/WalletControllerDtoDashboardMiningRequest';
import WalletControllerDtoDashboardMiningResponse from './model/WalletControllerDtoDashboardMiningResponse';
import WalletControllerDtoDashboardSummaryResponse from './model/WalletControllerDtoDashboardSummaryResponse';
import WalletControllerDtoDashboardUsageAndDestoryRequest from './model/WalletControllerDtoDashboardUsageAndDestoryRequest';
import WalletControllerDtoDashboardUsageAndDestoryResponse from './model/WalletControllerDtoDashboardUsageAndDestoryResponse';
import WalletControllerDtoDepositAddressRequest from './model/WalletControllerDtoDepositAddressRequest';
import WalletControllerDtoDepositAddressResponse from './model/WalletControllerDtoDepositAddressResponse';
import WalletControllerDtoDepositRequest from './model/WalletControllerDtoDepositRequest';
import WalletControllerDtoNotificationSettingInfoResponse from './model/WalletControllerDtoNotificationSettingInfoResponse';
import WalletControllerDtoNotificationSettingUpdateRequest from './model/WalletControllerDtoNotificationSettingUpdateRequest';
import WalletControllerDtoTokenSendConditionsInfoResponse from './model/WalletControllerDtoTokenSendConditionsInfoResponse';
import WalletControllerDtoTokenSendConditionsUpdateRequest from './model/WalletControllerDtoTokenSendConditionsUpdateRequest';
import WalletControllerDtoXperTgeRequest from './model/WalletControllerDtoXperTgeRequest';
import AllowedConnectionIpApi from './api/AllowedConnectionIpApi';
import CommonApi from './api/CommonApi';
import DashboardApi from './api/DashboardApi';
import InventoryApi from './api/InventoryApi';
import ManagerApi from './api/ManagerApi';
import ManagerAccountApi from './api/ManagerAccountApi';
import NftGeneratorApi from './api/NftGeneratorApi';
import PerplayAccountApi from './api/PerplayAccountApi';
import PerplayCampaignApi from './api/PerplayCampaignApi';
import PerplayCommunityApi from './api/PerplayCommunityApi';
import PerplayDailySettlementApi from './api/PerplayDailySettlementApi';
import PerplayEventsApi from './api/PerplayEventsApi';
import PerplayGameApi from './api/PerplayGameApi';
import PerplayLogApi from './api/PerplayLogApi';
import PerplayMarketApi from './api/PerplayMarketApi';
import PerplayMissionApi from './api/PerplayMissionApi';
import PerplayMonitoringApi from './api/PerplayMonitoringApi';
import PerplayNftApi from './api/PerplayNftApi';
import PerplayRankApi from './api/PerplayRankApi';
import PerplayStatisticsApi from './api/PerplayStatisticsApi';
import ReferralCodeApi from './api/ReferralCodeApi';
import SystemApi from './api/SystemApi';
import TestApi from './api/TestApi';
import WalletApi from './api/WalletApi';


/**
* JS API client generated by OpenAPI Generator.<br>
* The <code>index</code> module provides access to constructors for all the classes which comprise the public API.
* <p>
* An AMD (recommended!) or CommonJS application will generally do something equivalent to the following:
* <pre>
* var PerplayAdminApi = require('index'); // See note below*.
* var xxxSvc = new PerplayAdminApi.XxxApi(); // Allocate the API class we're going to use.
* var yyyModel = new PerplayAdminApi.Yyy(); // Construct a model instance.
* yyyModel.someProperty = 'someValue';
* ...
* var zzz = xxxSvc.doSomething(yyyModel); // Invoke the service.
* ...
* </pre>
* <em>*NOTE: For a top-level AMD script, use require(['index'], function(){...})
* and put the application logic within the callback function.</em>
* </p>
* <p>
* A non-AMD browser application (discouraged) might do something like this:
* <pre>
* var xxxSvc = new PerplayAdminApi.XxxApi(); // Allocate the API class we're going to use.
* var yyy = new PerplayAdminApi.Yyy(); // Construct a model instance.
* yyyModel.someProperty = 'someValue';
* ...
* var zzz = xxxSvc.doSomething(yyyModel); // Invoke the service.
* ...
* </pre>
* </p>
* @module index
* @version 1.0
*/
export {
    /**
     * The ApiClient constructor.
     * @property {module:ApiClient}
     */
    ApiClient,

    /**
     * The AccountControllerDtoAccountCurrentNicknameUpdateRequest model constructor.
     * @property {module:model/AccountControllerDtoAccountCurrentNicknameUpdateRequest}
     */
    AccountControllerDtoAccountCurrentNicknameUpdateRequest,

    /**
     * The AccountControllerDtoAccountCurrentPowerUpdateRequest model constructor.
     * @property {module:model/AccountControllerDtoAccountCurrentPowerUpdateRequest}
     */
    AccountControllerDtoAccountCurrentPowerUpdateRequest,

    /**
     * The AccountControllerDtoAccountDefaultInfoAccountPunishLightData model constructor.
     * @property {module:model/AccountControllerDtoAccountDefaultInfoAccountPunishLightData}
     */
    AccountControllerDtoAccountDefaultInfoAccountPunishLightData,

    /**
     * The AccountControllerDtoAccountDefaultInfoNicknameChangeLogHistoryData model constructor.
     * @property {module:model/AccountControllerDtoAccountDefaultInfoNicknameChangeLogHistoryData}
     */
    AccountControllerDtoAccountDefaultInfoNicknameChangeLogHistoryData,

    /**
     * The AccountControllerDtoAccountDefaultInfoRequest model constructor.
     * @property {module:model/AccountControllerDtoAccountDefaultInfoRequest}
     */
    AccountControllerDtoAccountDefaultInfoRequest,

    /**
     * The AccountControllerDtoAccountDefaultInfoResponse model constructor.
     * @property {module:model/AccountControllerDtoAccountDefaultInfoResponse}
     */
    AccountControllerDtoAccountDefaultInfoResponse,

    /**
     * The AccountControllerDtoAccountDefaultInfoWithdrawalData model constructor.
     * @property {module:model/AccountControllerDtoAccountDefaultInfoWithdrawalData}
     */
    AccountControllerDtoAccountDefaultInfoWithdrawalData,

    /**
     * The AccountControllerDtoAccountInventoryInfoAccountInventoryCar model constructor.
     * @property {module:model/AccountControllerDtoAccountInventoryInfoAccountInventoryCar}
     */
    AccountControllerDtoAccountInventoryInfoAccountInventoryCar,

    /**
     * The AccountControllerDtoAccountInventoryInfoAccountInventoryCarBox model constructor.
     * @property {module:model/AccountControllerDtoAccountInventoryInfoAccountInventoryCarBox}
     */
    AccountControllerDtoAccountInventoryInfoAccountInventoryCarBox,

    /**
     * The AccountControllerDtoAccountInventoryInfoAccountInventoryCarGemData model constructor.
     * @property {module:model/AccountControllerDtoAccountInventoryInfoAccountInventoryCarGemData}
     */
    AccountControllerDtoAccountInventoryInfoAccountInventoryCarGemData,

    /**
     * The AccountControllerDtoAccountInventoryInfoAccountInventoryGears model constructor.
     * @property {module:model/AccountControllerDtoAccountInventoryInfoAccountInventoryGears}
     */
    AccountControllerDtoAccountInventoryInfoAccountInventoryGears,

    /**
     * The AccountControllerDtoAccountInventoryInfoAccountInventoryItems model constructor.
     * @property {module:model/AccountControllerDtoAccountInventoryInfoAccountInventoryItems}
     */
    AccountControllerDtoAccountInventoryInfoAccountInventoryItems,

    /**
     * The AccountControllerDtoAccountInventoryInfoAccountInventorySpecialBox model constructor.
     * @property {module:model/AccountControllerDtoAccountInventoryInfoAccountInventorySpecialBox}
     */
    AccountControllerDtoAccountInventoryInfoAccountInventorySpecialBox,

    /**
     * The AccountControllerDtoAccountInventoryInfoAccountInventoryWallet model constructor.
     * @property {module:model/AccountControllerDtoAccountInventoryInfoAccountInventoryWallet}
     */
    AccountControllerDtoAccountInventoryInfoAccountInventoryWallet,

    /**
     * The AccountControllerDtoAccountInventoryInfoRequest model constructor.
     * @property {module:model/AccountControllerDtoAccountInventoryInfoRequest}
     */
    AccountControllerDtoAccountInventoryInfoRequest,

    /**
     * The AccountControllerDtoAccountInventoryInfoResponse model constructor.
     * @property {module:model/AccountControllerDtoAccountInventoryInfoResponse}
     */
    AccountControllerDtoAccountInventoryInfoResponse,

    /**
     * The AccountControllerDtoAccountListAccountData model constructor.
     * @property {module:model/AccountControllerDtoAccountListAccountData}
     */
    AccountControllerDtoAccountListAccountData,

    /**
     * The AccountControllerDtoAccountListRequest model constructor.
     * @property {module:model/AccountControllerDtoAccountListRequest}
     */
    AccountControllerDtoAccountListRequest,

    /**
     * The AccountControllerDtoAccountListResponse model constructor.
     * @property {module:model/AccountControllerDtoAccountListResponse}
     */
    AccountControllerDtoAccountListResponse,

    /**
     * The AccountControllerDtoAccountListWithdrawalData model constructor.
     * @property {module:model/AccountControllerDtoAccountListWithdrawalData}
     */
    AccountControllerDtoAccountListWithdrawalData,

    /**
     * The AccountControllerDtoAccountPunishStatusUpdateRequest model constructor.
     * @property {module:model/AccountControllerDtoAccountPunishStatusUpdateRequest}
     */
    AccountControllerDtoAccountPunishStatusUpdateRequest,

    /**
     * The AccountControllerDtoWithdrawalCancelRequest model constructor.
     * @property {module:model/AccountControllerDtoWithdrawalCancelRequest}
     */
    AccountControllerDtoWithdrawalCancelRequest,

    /**
     * The AccountControllerDtoWithdrawalLogListRequest model constructor.
     * @property {module:model/AccountControllerDtoWithdrawalLogListRequest}
     */
    AccountControllerDtoWithdrawalLogListRequest,

    /**
     * The AccountControllerDtoWithdrawalRequest model constructor.
     * @property {module:model/AccountControllerDtoWithdrawalRequest}
     */
    AccountControllerDtoWithdrawalRequest,

    /**
     * The AllowedConnectionIpControllerDtoAllowedConnectionIpCreateRequest model constructor.
     * @property {module:model/AllowedConnectionIpControllerDtoAllowedConnectionIpCreateRequest}
     */
    AllowedConnectionIpControllerDtoAllowedConnectionIpCreateRequest,

    /**
     * The AllowedConnectionIpControllerDtoAllowedConnectionIpListRequest model constructor.
     * @property {module:model/AllowedConnectionIpControllerDtoAllowedConnectionIpListRequest}
     */
    AllowedConnectionIpControllerDtoAllowedConnectionIpListRequest,

    /**
     * The AllowedConnectionIpControllerDtoAllowedConnectionIpListResponse model constructor.
     * @property {module:model/AllowedConnectionIpControllerDtoAllowedConnectionIpListResponse}
     */
    AllowedConnectionIpControllerDtoAllowedConnectionIpListResponse,

    /**
     * The AllowedConnectionIpControllerDtoAllowedConnectionIpRemoveRequest model constructor.
     * @property {module:model/AllowedConnectionIpControllerDtoAllowedConnectionIpRemoveRequest}
     */
    AllowedConnectionIpControllerDtoAllowedConnectionIpRemoveRequest,

    /**
     * The AllowedConnectionIpData model constructor.
     * @property {module:model/AllowedConnectionIpData}
     */
    AllowedConnectionIpData,

    /**
     * The ApiRoleData model constructor.
     * @property {module:model/ApiRoleData}
     */
    ApiRoleData,

    /**
     * The AuthorizationGroupData model constructor.
     * @property {module:model/AuthorizationGroupData}
     */
    AuthorizationGroupData,

    /**
     * The Balance model constructor.
     * @property {module:model/Balance}
     */
    Balance,

    /**
     * The BaseResponse model constructor.
     * @property {module:model/BaseResponse}
     */
    BaseResponse,

    /**
     * The CampaignControllerDtoAppDetailAppDetailDataList model constructor.
     * @property {module:model/CampaignControllerDtoAppDetailAppDetailDataList}
     */
    CampaignControllerDtoAppDetailAppDetailDataList,

    /**
     * The CampaignControllerDtoAppDetailRequest model constructor.
     * @property {module:model/CampaignControllerDtoAppDetailRequest}
     */
    CampaignControllerDtoAppDetailRequest,

    /**
     * The CampaignControllerDtoAppDetailResponse model constructor.
     * @property {module:model/CampaignControllerDtoAppDetailResponse}
     */
    CampaignControllerDtoAppDetailResponse,

    /**
     * The CampaignControllerDtoAppListAppData model constructor.
     * @property {module:model/CampaignControllerDtoAppListAppData}
     */
    CampaignControllerDtoAppListAppData,

    /**
     * The CampaignControllerDtoAppListRequest model constructor.
     * @property {module:model/CampaignControllerDtoAppListRequest}
     */
    CampaignControllerDtoAppListRequest,

    /**
     * The CampaignControllerDtoAppListResponse model constructor.
     * @property {module:model/CampaignControllerDtoAppListResponse}
     */
    CampaignControllerDtoAppListResponse,

    /**
     * The CampaignControllerDtoAppRemoveRequest model constructor.
     * @property {module:model/CampaignControllerDtoAppRemoveRequest}
     */
    CampaignControllerDtoAppRemoveRequest,

    /**
     * The CampaignControllerDtoAppRemoveResponse model constructor.
     * @property {module:model/CampaignControllerDtoAppRemoveResponse}
     */
    CampaignControllerDtoAppRemoveResponse,

    /**
     * The CampaignControllerDtoAppSearchAppSearchData model constructor.
     * @property {module:model/CampaignControllerDtoAppSearchAppSearchData}
     */
    CampaignControllerDtoAppSearchAppSearchData,

    /**
     * The CampaignControllerDtoAppSearchRequest model constructor.
     * @property {module:model/CampaignControllerDtoAppSearchRequest}
     */
    CampaignControllerDtoAppSearchRequest,

    /**
     * The CampaignControllerDtoAppSearchResponse model constructor.
     * @property {module:model/CampaignControllerDtoAppSearchResponse}
     */
    CampaignControllerDtoAppSearchResponse,

    /**
     * The CampaignControllerDtoAppUpdateRequest model constructor.
     * @property {module:model/CampaignControllerDtoAppUpdateRequest}
     */
    CampaignControllerDtoAppUpdateRequest,

    /**
     * The CampaignControllerDtoAppUpdateResponse model constructor.
     * @property {module:model/CampaignControllerDtoAppUpdateResponse}
     */
    CampaignControllerDtoAppUpdateResponse,

    /**
     * The CampaignControllerDtoAppVersionUpdateRequest model constructor.
     * @property {module:model/CampaignControllerDtoAppVersionUpdateRequest}
     */
    CampaignControllerDtoAppVersionUpdateRequest,

    /**
     * The CampaignControllerDtoCampaignDetailCampaignDetailData model constructor.
     * @property {module:model/CampaignControllerDtoCampaignDetailCampaignDetailData}
     */
    CampaignControllerDtoCampaignDetailCampaignDetailData,

    /**
     * The CampaignControllerDtoCampaignDetailRequest model constructor.
     * @property {module:model/CampaignControllerDtoCampaignDetailRequest}
     */
    CampaignControllerDtoCampaignDetailRequest,

    /**
     * The CampaignControllerDtoCampaignDetailResponse model constructor.
     * @property {module:model/CampaignControllerDtoCampaignDetailResponse}
     */
    CampaignControllerDtoCampaignDetailResponse,

    /**
     * The CampaignControllerDtoCampaignListCampaignData model constructor.
     * @property {module:model/CampaignControllerDtoCampaignListCampaignData}
     */
    CampaignControllerDtoCampaignListCampaignData,

    /**
     * The CampaignControllerDtoCampaignListRequest model constructor.
     * @property {module:model/CampaignControllerDtoCampaignListRequest}
     */
    CampaignControllerDtoCampaignListRequest,

    /**
     * The CampaignControllerDtoCampaignListResponse model constructor.
     * @property {module:model/CampaignControllerDtoCampaignListResponse}
     */
    CampaignControllerDtoCampaignListResponse,

    /**
     * The CampaignControllerDtoCampaignLockStateRequest model constructor.
     * @property {module:model/CampaignControllerDtoCampaignLockStateRequest}
     */
    CampaignControllerDtoCampaignLockStateRequest,

    /**
     * The CampaignControllerDtoCampaignRemoveRequest model constructor.
     * @property {module:model/CampaignControllerDtoCampaignRemoveRequest}
     */
    CampaignControllerDtoCampaignRemoveRequest,

    /**
     * The CampaignControllerDtoCampaignSortRequest model constructor.
     * @property {module:model/CampaignControllerDtoCampaignSortRequest}
     */
    CampaignControllerDtoCampaignSortRequest,

    /**
     * The CampaignControllerDtoCampaignTerminateRequest model constructor.
     * @property {module:model/CampaignControllerDtoCampaignTerminateRequest}
     */
    CampaignControllerDtoCampaignTerminateRequest,

    /**
     * The CampaignControllerDtoCreateAppRequest model constructor.
     * @property {module:model/CampaignControllerDtoCreateAppRequest}
     */
    CampaignControllerDtoCreateAppRequest,

    /**
     * The CampaignControllerDtoCreateAppResponse model constructor.
     * @property {module:model/CampaignControllerDtoCreateAppResponse}
     */
    CampaignControllerDtoCreateAppResponse,

    /**
     * The CampaignControllerDtoPlayStoreSearchRequest model constructor.
     * @property {module:model/CampaignControllerDtoPlayStoreSearchRequest}
     */
    CampaignControllerDtoPlayStoreSearchRequest,

    /**
     * The CampaignControllerDtoPlayStoreSearchResponse model constructor.
     * @property {module:model/CampaignControllerDtoPlayStoreSearchResponse}
     */
    CampaignControllerDtoPlayStoreSearchResponse,

    /**
     * The CampaignControllerDtoResourceUpdateRequest model constructor.
     * @property {module:model/CampaignControllerDtoResourceUpdateRequest}
     */
    CampaignControllerDtoResourceUpdateRequest,

    /**
     * The CampaignControllerDtoWhiteListAddRequest model constructor.
     * @property {module:model/CampaignControllerDtoWhiteListAddRequest}
     */
    CampaignControllerDtoWhiteListAddRequest,

    /**
     * The CampaignControllerDtoWhiteListRemoveRequest model constructor.
     * @property {module:model/CampaignControllerDtoWhiteListRemoveRequest}
     */
    CampaignControllerDtoWhiteListRemoveRequest,

    /**
     * The CampaignSortData model constructor.
     * @property {module:model/CampaignSortData}
     */
    CampaignSortData,

    /**
     * The CategoryListGnb model constructor.
     * @property {module:model/CategoryListGnb}
     */
    CategoryListGnb,

    /**
     * The CategoryListLnb model constructor.
     * @property {module:model/CategoryListLnb}
     */
    CategoryListLnb,

    /**
     * The CategoryListSub model constructor.
     * @property {module:model/CategoryListSub}
     */
    CategoryListSub,

    /**
     * The CollaboType model constructor.
     * @property {module:model/CollaboType}
     */
    CollaboType,

    /**
     * The CommunityControllerDtoPostAccountSearchRequest model constructor.
     * @property {module:model/CommunityControllerDtoPostAccountSearchRequest}
     */
    CommunityControllerDtoPostAccountSearchRequest,

    /**
     * The CommunityControllerDtoPostAccountSearchResponse model constructor.
     * @property {module:model/CommunityControllerDtoPostAccountSearchResponse}
     */
    CommunityControllerDtoPostAccountSearchResponse,

    /**
     * The CommunityControllerDtoPostCreateFromExcelResponse model constructor.
     * @property {module:model/CommunityControllerDtoPostCreateFromExcelResponse}
     */
    CommunityControllerDtoPostCreateFromExcelResponse,

    /**
     * The CommunityControllerDtoPostCreateResponse model constructor.
     * @property {module:model/CommunityControllerDtoPostCreateResponse}
     */
    CommunityControllerDtoPostCreateResponse,

    /**
     * The CommunityControllerDtoPostDetailRequest model constructor.
     * @property {module:model/CommunityControllerDtoPostDetailRequest}
     */
    CommunityControllerDtoPostDetailRequest,

    /**
     * The CommunityControllerDtoPostDetailResponse model constructor.
     * @property {module:model/CommunityControllerDtoPostDetailResponse}
     */
    CommunityControllerDtoPostDetailResponse,

    /**
     * The CommunityControllerDtoPostExcelDownloadRequest model constructor.
     * @property {module:model/CommunityControllerDtoPostExcelDownloadRequest}
     */
    CommunityControllerDtoPostExcelDownloadRequest,

    /**
     * The CommunityControllerDtoPostListRequest model constructor.
     * @property {module:model/CommunityControllerDtoPostListRequest}
     */
    CommunityControllerDtoPostListRequest,

    /**
     * The CommunityControllerDtoPostListResponse model constructor.
     * @property {module:model/CommunityControllerDtoPostListResponse}
     */
    CommunityControllerDtoPostListResponse,

    /**
     * The CommunityControllerDtoPostRemoveRequest model constructor.
     * @property {module:model/CommunityControllerDtoPostRemoveRequest}
     */
    CommunityControllerDtoPostRemoveRequest,

    /**
     * The ContentsIndex model constructor.
     * @property {module:model/ContentsIndex}
     */
    ContentsIndex,

    /**
     * The ContentsWalletListData model constructor.
     * @property {module:model/ContentsWalletListData}
     */
    ContentsWalletListData,

    /**
     * The DashboardAvailableBalanceData model constructor.
     * @property {module:model/DashboardAvailableBalanceData}
     */
    DashboardAvailableBalanceData,

    /**
     * The DashboardControllerDtoGetDashboardDataDurationType model constructor.
     * @property {module:model/DashboardControllerDtoGetDashboardDataDurationType}
     */
    DashboardControllerDtoGetDashboardDataDurationType,

    /**
     * The DashboardControllerDtoGetDashboardDataMiningStatistics model constructor.
     * @property {module:model/DashboardControllerDtoGetDashboardDataMiningStatistics}
     */
    DashboardControllerDtoGetDashboardDataMiningStatistics,

    /**
     * The DashboardControllerDtoGetDashboardDataRequest model constructor.
     * @property {module:model/DashboardControllerDtoGetDashboardDataRequest}
     */
    DashboardControllerDtoGetDashboardDataRequest,

    /**
     * The DashboardControllerDtoGetDashboardDataResponse model constructor.
     * @property {module:model/DashboardControllerDtoGetDashboardDataResponse}
     */
    DashboardControllerDtoGetDashboardDataResponse,

    /**
     * The DashboardControllerDtoGetDashboardDataTransactionStatistics model constructor.
     * @property {module:model/DashboardControllerDtoGetDashboardDataTransactionStatistics}
     */
    DashboardControllerDtoGetDashboardDataTransactionStatistics,

    /**
     * The DashboardControllerDtoGetDashboardDataUserStatistics model constructor.
     * @property {module:model/DashboardControllerDtoGetDashboardDataUserStatistics}
     */
    DashboardControllerDtoGetDashboardDataUserStatistics,

    /**
     * The DashboardControllerDtoGetDashboardDataWalletData model constructor.
     * @property {module:model/DashboardControllerDtoGetDashboardDataWalletData}
     */
    DashboardControllerDtoGetDashboardDataWalletData,

    /**
     * The DashboardMiningData model constructor.
     * @property {module:model/DashboardMiningData}
     */
    DashboardMiningData,

    /**
     * The DashboardUsageAndDestroyData model constructor.
     * @property {module:model/DashboardUsageAndDestroyData}
     */
    DashboardUsageAndDestroyData,

    /**
     * The DepartmentData model constructor.
     * @property {module:model/DepartmentData}
     */
    DepartmentData,

    /**
     * The DistributionChannel model constructor.
     * @property {module:model/DistributionChannel}
     */
    DistributionChannel,

    /**
     * The EventsControllerDtoBannerListBannerData model constructor.
     * @property {module:model/EventsControllerDtoBannerListBannerData}
     */
    EventsControllerDtoBannerListBannerData,

    /**
     * The EventsControllerDtoBannerListImageData model constructor.
     * @property {module:model/EventsControllerDtoBannerListImageData}
     */
    EventsControllerDtoBannerListImageData,

    /**
     * The EventsControllerDtoBannerListRequest model constructor.
     * @property {module:model/EventsControllerDtoBannerListRequest}
     */
    EventsControllerDtoBannerListRequest,

    /**
     * The EventsControllerDtoBannerListResponse model constructor.
     * @property {module:model/EventsControllerDtoBannerListResponse}
     */
    EventsControllerDtoBannerListResponse,

    /**
     * The EventsControllerDtoBannerRemoveRequest model constructor.
     * @property {module:model/EventsControllerDtoBannerRemoveRequest}
     */
    EventsControllerDtoBannerRemoveRequest,

    /**
     * The EventsControllerDtoBannerSortUpdateRequest model constructor.
     * @property {module:model/EventsControllerDtoBannerSortUpdateRequest}
     */
    EventsControllerDtoBannerSortUpdateRequest,

    /**
     * The EventsControllerDtoDrawItemCreateResponse model constructor.
     * @property {module:model/EventsControllerDtoDrawItemCreateResponse}
     */
    EventsControllerDtoDrawItemCreateResponse,

    /**
     * The EventsControllerDtoDrawItemDetailDrawItemRewardDetailData model constructor.
     * @property {module:model/EventsControllerDtoDrawItemDetailDrawItemRewardDetailData}
     */
    EventsControllerDtoDrawItemDetailDrawItemRewardDetailData,

    /**
     * The EventsControllerDtoDrawItemDetailImageData model constructor.
     * @property {module:model/EventsControllerDtoDrawItemDetailImageData}
     */
    EventsControllerDtoDrawItemDetailImageData,

    /**
     * The EventsControllerDtoDrawItemDetailRequest model constructor.
     * @property {module:model/EventsControllerDtoDrawItemDetailRequest}
     */
    EventsControllerDtoDrawItemDetailRequest,

    /**
     * The EventsControllerDtoDrawItemDetailResponse model constructor.
     * @property {module:model/EventsControllerDtoDrawItemDetailResponse}
     */
    EventsControllerDtoDrawItemDetailResponse,

    /**
     * The EventsControllerDtoDrawItemListDrawItemInfoData model constructor.
     * @property {module:model/EventsControllerDtoDrawItemListDrawItemInfoData}
     */
    EventsControllerDtoDrawItemListDrawItemInfoData,

    /**
     * The EventsControllerDtoDrawItemListRequest model constructor.
     * @property {module:model/EventsControllerDtoDrawItemListRequest}
     */
    EventsControllerDtoDrawItemListRequest,

    /**
     * The EventsControllerDtoDrawItemListResponse model constructor.
     * @property {module:model/EventsControllerDtoDrawItemListResponse}
     */
    EventsControllerDtoDrawItemListResponse,

    /**
     * The EventsControllerDtoDrawItemLogListDrawItemLogData model constructor.
     * @property {module:model/EventsControllerDtoDrawItemLogListDrawItemLogData}
     */
    EventsControllerDtoDrawItemLogListDrawItemLogData,

    /**
     * The EventsControllerDtoDrawItemLogListRequest model constructor.
     * @property {module:model/EventsControllerDtoDrawItemLogListRequest}
     */
    EventsControllerDtoDrawItemLogListRequest,

    /**
     * The EventsControllerDtoDrawItemLogListResponse model constructor.
     * @property {module:model/EventsControllerDtoDrawItemLogListResponse}
     */
    EventsControllerDtoDrawItemLogListResponse,

    /**
     * The EventsControllerDtoDrawItemRemoveRequest model constructor.
     * @property {module:model/EventsControllerDtoDrawItemRemoveRequest}
     */
    EventsControllerDtoDrawItemRemoveRequest,

    /**
     * The EventsControllerDtoEventFreeNftCreateRequest model constructor.
     * @property {module:model/EventsControllerDtoEventFreeNftCreateRequest}
     */
    EventsControllerDtoEventFreeNftCreateRequest,

    /**
     * The EventsControllerDtoEventFreeNftDetailRequest model constructor.
     * @property {module:model/EventsControllerDtoEventFreeNftDetailRequest}
     */
    EventsControllerDtoEventFreeNftDetailRequest,

    /**
     * The EventsControllerDtoEventFreeNftDetailResponse model constructor.
     * @property {module:model/EventsControllerDtoEventFreeNftDetailResponse}
     */
    EventsControllerDtoEventFreeNftDetailResponse,

    /**
     * The EventsControllerDtoEventFreeNftHistoryListEventFreeNftHistoryData model constructor.
     * @property {module:model/EventsControllerDtoEventFreeNftHistoryListEventFreeNftHistoryData}
     */
    EventsControllerDtoEventFreeNftHistoryListEventFreeNftHistoryData,

    /**
     * The EventsControllerDtoEventFreeNftHistoryListRequest model constructor.
     * @property {module:model/EventsControllerDtoEventFreeNftHistoryListRequest}
     */
    EventsControllerDtoEventFreeNftHistoryListRequest,

    /**
     * The EventsControllerDtoEventFreeNftHistoryListResponse model constructor.
     * @property {module:model/EventsControllerDtoEventFreeNftHistoryListResponse}
     */
    EventsControllerDtoEventFreeNftHistoryListResponse,

    /**
     * The EventsControllerDtoEventFreeNftListEventFreeNftData model constructor.
     * @property {module:model/EventsControllerDtoEventFreeNftListEventFreeNftData}
     */
    EventsControllerDtoEventFreeNftListEventFreeNftData,

    /**
     * The EventsControllerDtoEventFreeNftListRequest model constructor.
     * @property {module:model/EventsControllerDtoEventFreeNftListRequest}
     */
    EventsControllerDtoEventFreeNftListRequest,

    /**
     * The EventsControllerDtoEventFreeNftListResponse model constructor.
     * @property {module:model/EventsControllerDtoEventFreeNftListResponse}
     */
    EventsControllerDtoEventFreeNftListResponse,

    /**
     * The EventsControllerDtoEventFreeNftRemoveRequest model constructor.
     * @property {module:model/EventsControllerDtoEventFreeNftRemoveRequest}
     */
    EventsControllerDtoEventFreeNftRemoveRequest,

    /**
     * The EventsControllerDtoEventFreeNftUpdateRequest model constructor.
     * @property {module:model/EventsControllerDtoEventFreeNftUpdateRequest}
     */
    EventsControllerDtoEventFreeNftUpdateRequest,

    /**
     * The EventsControllerDtoEventInvitationHistoryListEventInvitationHistoryData model constructor.
     * @property {module:model/EventsControllerDtoEventInvitationHistoryListEventInvitationHistoryData}
     */
    EventsControllerDtoEventInvitationHistoryListEventInvitationHistoryData,

    /**
     * The EventsControllerDtoEventInvitationHistoryListRequest model constructor.
     * @property {module:model/EventsControllerDtoEventInvitationHistoryListRequest}
     */
    EventsControllerDtoEventInvitationHistoryListRequest,

    /**
     * The EventsControllerDtoEventInvitationHistoryListResponse model constructor.
     * @property {module:model/EventsControllerDtoEventInvitationHistoryListResponse}
     */
    EventsControllerDtoEventInvitationHistoryListResponse,

    /**
     * The EventsControllerDtoEventInvitationInfosCreateRequest model constructor.
     * @property {module:model/EventsControllerDtoEventInvitationInfosCreateRequest}
     */
    EventsControllerDtoEventInvitationInfosCreateRequest,

    /**
     * The EventsControllerDtoEventInvitationInfosDetailRequest model constructor.
     * @property {module:model/EventsControllerDtoEventInvitationInfosDetailRequest}
     */
    EventsControllerDtoEventInvitationInfosDetailRequest,

    /**
     * The EventsControllerDtoEventInvitationInfosDetailResponse model constructor.
     * @property {module:model/EventsControllerDtoEventInvitationInfosDetailResponse}
     */
    EventsControllerDtoEventInvitationInfosDetailResponse,

    /**
     * The EventsControllerDtoEventInvitationInfosListEventInvitationInfosData model constructor.
     * @property {module:model/EventsControllerDtoEventInvitationInfosListEventInvitationInfosData}
     */
    EventsControllerDtoEventInvitationInfosListEventInvitationInfosData,

    /**
     * The EventsControllerDtoEventInvitationInfosListRequest model constructor.
     * @property {module:model/EventsControllerDtoEventInvitationInfosListRequest}
     */
    EventsControllerDtoEventInvitationInfosListRequest,

    /**
     * The EventsControllerDtoEventInvitationInfosListResponse model constructor.
     * @property {module:model/EventsControllerDtoEventInvitationInfosListResponse}
     */
    EventsControllerDtoEventInvitationInfosListResponse,

    /**
     * The EventsControllerDtoEventInvitationInfosRemoveRequest model constructor.
     * @property {module:model/EventsControllerDtoEventInvitationInfosRemoveRequest}
     */
    EventsControllerDtoEventInvitationInfosRemoveRequest,

    /**
     * The EventsControllerDtoEventInvitationInfosUpdateRequest model constructor.
     * @property {module:model/EventsControllerDtoEventInvitationInfosUpdateRequest}
     */
    EventsControllerDtoEventInvitationInfosUpdateRequest,

    /**
     * The EventsControllerDtoEventInvitationPartnerCreateRequest model constructor.
     * @property {module:model/EventsControllerDtoEventInvitationPartnerCreateRequest}
     */
    EventsControllerDtoEventInvitationPartnerCreateRequest,

    /**
     * The EventsControllerDtoEventInvitationPartnerDetailEventInvitationPartnerDetailListData model constructor.
     * @property {module:model/EventsControllerDtoEventInvitationPartnerDetailEventInvitationPartnerDetailListData}
     */
    EventsControllerDtoEventInvitationPartnerDetailEventInvitationPartnerDetailListData,

    /**
     * The EventsControllerDtoEventInvitationPartnerDetailRequest model constructor.
     * @property {module:model/EventsControllerDtoEventInvitationPartnerDetailRequest}
     */
    EventsControllerDtoEventInvitationPartnerDetailRequest,

    /**
     * The EventsControllerDtoEventInvitationPartnerDetailResponse model constructor.
     * @property {module:model/EventsControllerDtoEventInvitationPartnerDetailResponse}
     */
    EventsControllerDtoEventInvitationPartnerDetailResponse,

    /**
     * The EventsControllerDtoEventInvitationPartnerListEventInvitationPartnerListData model constructor.
     * @property {module:model/EventsControllerDtoEventInvitationPartnerListEventInvitationPartnerListData}
     */
    EventsControllerDtoEventInvitationPartnerListEventInvitationPartnerListData,

    /**
     * The EventsControllerDtoEventInvitationPartnerListRequest model constructor.
     * @property {module:model/EventsControllerDtoEventInvitationPartnerListRequest}
     */
    EventsControllerDtoEventInvitationPartnerListRequest,

    /**
     * The EventsControllerDtoEventInvitationPartnerListResponse model constructor.
     * @property {module:model/EventsControllerDtoEventInvitationPartnerListResponse}
     */
    EventsControllerDtoEventInvitationPartnerListResponse,

    /**
     * The EventsControllerDtoEventInvitationPartnerRewardListEventInvitationPartnerRewardListData model constructor.
     * @property {module:model/EventsControllerDtoEventInvitationPartnerRewardListEventInvitationPartnerRewardListData}
     */
    EventsControllerDtoEventInvitationPartnerRewardListEventInvitationPartnerRewardListData,

    /**
     * The EventsControllerDtoEventInvitationPartnerRewardListRequest model constructor.
     * @property {module:model/EventsControllerDtoEventInvitationPartnerRewardListRequest}
     */
    EventsControllerDtoEventInvitationPartnerRewardListRequest,

    /**
     * The EventsControllerDtoEventInvitationPartnerRewardListResponse model constructor.
     * @property {module:model/EventsControllerDtoEventInvitationPartnerRewardListResponse}
     */
    EventsControllerDtoEventInvitationPartnerRewardListResponse,

    /**
     * The EventsControllerDtoEventInvitationPartnerUpdateRequest model constructor.
     * @property {module:model/EventsControllerDtoEventInvitationPartnerUpdateRequest}
     */
    EventsControllerDtoEventInvitationPartnerUpdateRequest,

    /**
     * The EventsControllerDtoEventInvitationRewardListEventInvitationRewardData model constructor.
     * @property {module:model/EventsControllerDtoEventInvitationRewardListEventInvitationRewardData}
     */
    EventsControllerDtoEventInvitationRewardListEventInvitationRewardData,

    /**
     * The EventsControllerDtoEventInvitationRewardListRequest model constructor.
     * @property {module:model/EventsControllerDtoEventInvitationRewardListRequest}
     */
    EventsControllerDtoEventInvitationRewardListRequest,

    /**
     * The EventsControllerDtoEventInvitationRewardListResponse model constructor.
     * @property {module:model/EventsControllerDtoEventInvitationRewardListResponse}
     */
    EventsControllerDtoEventInvitationRewardListResponse,

    /**
     * The EventsControllerDtoEventRaffleHistoryListListData model constructor.
     * @property {module:model/EventsControllerDtoEventRaffleHistoryListListData}
     */
    EventsControllerDtoEventRaffleHistoryListListData,

    /**
     * The EventsControllerDtoEventRaffleHistoryListRequest model constructor.
     * @property {module:model/EventsControllerDtoEventRaffleHistoryListRequest}
     */
    EventsControllerDtoEventRaffleHistoryListRequest,

    /**
     * The EventsControllerDtoEventRaffleHistoryListResponse model constructor.
     * @property {module:model/EventsControllerDtoEventRaffleHistoryListResponse}
     */
    EventsControllerDtoEventRaffleHistoryListResponse,

    /**
     * The EventsControllerDtoEventStarterPackHistoryListEventStarterPackHistoryData model constructor.
     * @property {module:model/EventsControllerDtoEventStarterPackHistoryListEventStarterPackHistoryData}
     */
    EventsControllerDtoEventStarterPackHistoryListEventStarterPackHistoryData,

    /**
     * The EventsControllerDtoEventStarterPackHistoryListRequest model constructor.
     * @property {module:model/EventsControllerDtoEventStarterPackHistoryListRequest}
     */
    EventsControllerDtoEventStarterPackHistoryListRequest,

    /**
     * The EventsControllerDtoEventStarterPackHistoryListResponse model constructor.
     * @property {module:model/EventsControllerDtoEventStarterPackHistoryListResponse}
     */
    EventsControllerDtoEventStarterPackHistoryListResponse,

    /**
     * The EventsControllerDtoEventStarterPackInfoAddBudgetRequest model constructor.
     * @property {module:model/EventsControllerDtoEventStarterPackInfoAddBudgetRequest}
     */
    EventsControllerDtoEventStarterPackInfoAddBudgetRequest,

    /**
     * The EventsControllerDtoEventStarterPackInfoCreateRequest model constructor.
     * @property {module:model/EventsControllerDtoEventStarterPackInfoCreateRequest}
     */
    EventsControllerDtoEventStarterPackInfoCreateRequest,

    /**
     * The EventsControllerDtoEventStarterPackInfoDepositRequest model constructor.
     * @property {module:model/EventsControllerDtoEventStarterPackInfoDepositRequest}
     */
    EventsControllerDtoEventStarterPackInfoDepositRequest,

    /**
     * The EventsControllerDtoEventStarterPackInfoDetailRequest model constructor.
     * @property {module:model/EventsControllerDtoEventStarterPackInfoDetailRequest}
     */
    EventsControllerDtoEventStarterPackInfoDetailRequest,

    /**
     * The EventsControllerDtoEventStarterPackInfoDetailResponse model constructor.
     * @property {module:model/EventsControllerDtoEventStarterPackInfoDetailResponse}
     */
    EventsControllerDtoEventStarterPackInfoDetailResponse,

    /**
     * The EventsControllerDtoEventStarterPackInfoListEventStarterPackInfoData model constructor.
     * @property {module:model/EventsControllerDtoEventStarterPackInfoListEventStarterPackInfoData}
     */
    EventsControllerDtoEventStarterPackInfoListEventStarterPackInfoData,

    /**
     * The EventsControllerDtoEventStarterPackInfoListRequest model constructor.
     * @property {module:model/EventsControllerDtoEventStarterPackInfoListRequest}
     */
    EventsControllerDtoEventStarterPackInfoListRequest,

    /**
     * The EventsControllerDtoEventStarterPackInfoListResponse model constructor.
     * @property {module:model/EventsControllerDtoEventStarterPackInfoListResponse}
     */
    EventsControllerDtoEventStarterPackInfoListResponse,

    /**
     * The EventsControllerDtoEventStarterPackInfoRemoveRequest model constructor.
     * @property {module:model/EventsControllerDtoEventStarterPackInfoRemoveRequest}
     */
    EventsControllerDtoEventStarterPackInfoRemoveRequest,

    /**
     * The EventsControllerDtoEventStarterPackInfoUpdateRequest model constructor.
     * @property {module:model/EventsControllerDtoEventStarterPackInfoUpdateRequest}
     */
    EventsControllerDtoEventStarterPackInfoUpdateRequest,

    /**
     * The EventsControllerDtoNoticeListImageData model constructor.
     * @property {module:model/EventsControllerDtoNoticeListImageData}
     */
    EventsControllerDtoNoticeListImageData,

    /**
     * The EventsControllerDtoNoticeListNoticeData model constructor.
     * @property {module:model/EventsControllerDtoNoticeListNoticeData}
     */
    EventsControllerDtoNoticeListNoticeData,

    /**
     * The EventsControllerDtoNoticeListRequest model constructor.
     * @property {module:model/EventsControllerDtoNoticeListRequest}
     */
    EventsControllerDtoNoticeListRequest,

    /**
     * The EventsControllerDtoNoticeListResponse model constructor.
     * @property {module:model/EventsControllerDtoNoticeListResponse}
     */
    EventsControllerDtoNoticeListResponse,

    /**
     * The EventsControllerDtoNoticeRemoveRequest model constructor.
     * @property {module:model/EventsControllerDtoNoticeRemoveRequest}
     */
    EventsControllerDtoNoticeRemoveRequest,

    /**
     * The EventsControllerDtoNoticeSortUpdateRequest model constructor.
     * @property {module:model/EventsControllerDtoNoticeSortUpdateRequest}
     */
    EventsControllerDtoNoticeSortUpdateRequest,

    /**
     * The EventsControllerDtoRaffleInfoRequest model constructor.
     * @property {module:model/EventsControllerDtoRaffleInfoRequest}
     */
    EventsControllerDtoRaffleInfoRequest,

    /**
     * The EventsControllerDtoRaffleInfoResponse model constructor.
     * @property {module:model/EventsControllerDtoRaffleInfoResponse}
     */
    EventsControllerDtoRaffleInfoResponse,

    /**
     * The EventsControllerDtoRaffleListListData model constructor.
     * @property {module:model/EventsControllerDtoRaffleListListData}
     */
    EventsControllerDtoRaffleListListData,

    /**
     * The EventsControllerDtoRaffleListRequest model constructor.
     * @property {module:model/EventsControllerDtoRaffleListRequest}
     */
    EventsControllerDtoRaffleListRequest,

    /**
     * The EventsControllerDtoRaffleListResponse model constructor.
     * @property {module:model/EventsControllerDtoRaffleListResponse}
     */
    EventsControllerDtoRaffleListResponse,

    /**
     * The EventsControllerDtoRaffleUpsertRequest model constructor.
     * @property {module:model/EventsControllerDtoRaffleUpsertRequest}
     */
    EventsControllerDtoRaffleUpsertRequest,

    /**
     * The EvolveLogData model constructor.
     * @property {module:model/EvolveLogData}
     */
    EvolveLogData,

    /**
     * The ExchangeRateData model constructor.
     * @property {module:model/ExchangeRateData}
     */
    ExchangeRateData,

    /**
     * The GameControllerDtoConfigItemListConfigItemData model constructor.
     * @property {module:model/GameControllerDtoConfigItemListConfigItemData}
     */
    GameControllerDtoConfigItemListConfigItemData,

    /**
     * The GameControllerDtoConfigItemListRequest model constructor.
     * @property {module:model/GameControllerDtoConfigItemListRequest}
     */
    GameControllerDtoConfigItemListRequest,

    /**
     * The GameControllerDtoConfigItemListResponse model constructor.
     * @property {module:model/GameControllerDtoConfigItemListResponse}
     */
    GameControllerDtoConfigItemListResponse,

    /**
     * The GameControllerDtoGameConfigCreateRequest model constructor.
     * @property {module:model/GameControllerDtoGameConfigCreateRequest}
     */
    GameControllerDtoGameConfigCreateRequest,

    /**
     * The GameControllerDtoGameConfigInfoGameConfigInfoData model constructor.
     * @property {module:model/GameControllerDtoGameConfigInfoGameConfigInfoData}
     */
    GameControllerDtoGameConfigInfoGameConfigInfoData,

    /**
     * The GameControllerDtoGameConfigInfoResponse model constructor.
     * @property {module:model/GameControllerDtoGameConfigInfoResponse}
     */
    GameControllerDtoGameConfigInfoResponse,

    /**
     * The GameControllerDtoGameConfigRemoveRequest model constructor.
     * @property {module:model/GameControllerDtoGameConfigRemoveRequest}
     */
    GameControllerDtoGameConfigRemoveRequest,

    /**
     * The GameControllerDtoGameConfigRemoveResponse model constructor.
     * @property {module:model/GameControllerDtoGameConfigRemoveResponse}
     */
    GameControllerDtoGameConfigRemoveResponse,

    /**
     * The GameControllerDtoGameConfigUpdateRequest model constructor.
     * @property {module:model/GameControllerDtoGameConfigUpdateRequest}
     */
    GameControllerDtoGameConfigUpdateRequest,

    /**
     * The GameControllerDtoGameConfigUpdateResponse model constructor.
     * @property {module:model/GameControllerDtoGameConfigUpdateResponse}
     */
    GameControllerDtoGameConfigUpdateResponse,

    /**
     * The GameControllerDtoMaterialConfigCheckResponse model constructor.
     * @property {module:model/GameControllerDtoMaterialConfigCheckResponse}
     */
    GameControllerDtoMaterialConfigCheckResponse,

    /**
     * The GameControllerDtoMaterialConfigInfoMaterialConfigInfoData model constructor.
     * @property {module:model/GameControllerDtoMaterialConfigInfoMaterialConfigInfoData}
     */
    GameControllerDtoMaterialConfigInfoMaterialConfigInfoData,

    /**
     * The GameControllerDtoMaterialConfigInfoResponse model constructor.
     * @property {module:model/GameControllerDtoMaterialConfigInfoResponse}
     */
    GameControllerDtoMaterialConfigInfoResponse,

    /**
     * The GameType model constructor.
     * @property {module:model/GameType}
     */
    GameType,

    /**
     * The GemColor model constructor.
     * @property {module:model/GemColor}
     */
    GemColor,

    /**
     * The GemEffect model constructor.
     * @property {module:model/GemEffect}
     */
    GemEffect,

    /**
     * The GroupRoleCategoryData model constructor.
     * @property {module:model/GroupRoleCategoryData}
     */
    GroupRoleCategoryData,

    /**
     * The GroupRoleUpdateData model constructor.
     * @property {module:model/GroupRoleUpdateData}
     */
    GroupRoleUpdateData,

    /**
     * The InventoryControllerDtoItemGroupListItemGroupListData model constructor.
     * @property {module:model/InventoryControllerDtoItemGroupListItemGroupListData}
     */
    InventoryControllerDtoItemGroupListItemGroupListData,

    /**
     * The InventoryControllerDtoItemGroupListRequest model constructor.
     * @property {module:model/InventoryControllerDtoItemGroupListRequest}
     */
    InventoryControllerDtoItemGroupListRequest,

    /**
     * The InventoryControllerDtoItemGroupListResponse model constructor.
     * @property {module:model/InventoryControllerDtoItemGroupListResponse}
     */
    InventoryControllerDtoItemGroupListResponse,

    /**
     * The InventoryControllerDtoItemRemoveRequest model constructor.
     * @property {module:model/InventoryControllerDtoItemRemoveRequest}
     */
    InventoryControllerDtoItemRemoveRequest,

    /**
     * The InventoryControllerDtoNftInventoryValidUpdateRequest model constructor.
     * @property {module:model/InventoryControllerDtoNftInventoryValidUpdateRequest}
     */
    InventoryControllerDtoNftInventoryValidUpdateRequest,

    /**
     * The LogControllerDtoAccountHolderChangeLogListAccountHolderChangeLogData model constructor.
     * @property {module:model/LogControllerDtoAccountHolderChangeLogListAccountHolderChangeLogData}
     */
    LogControllerDtoAccountHolderChangeLogListAccountHolderChangeLogData,

    /**
     * The LogControllerDtoAccountHolderChangeLogListRequest model constructor.
     * @property {module:model/LogControllerDtoAccountHolderChangeLogListRequest}
     */
    LogControllerDtoAccountHolderChangeLogListRequest,

    /**
     * The LogControllerDtoAccountHolderChangeLogListResponse model constructor.
     * @property {module:model/LogControllerDtoAccountHolderChangeLogListResponse}
     */
    LogControllerDtoAccountHolderChangeLogListResponse,

    /**
     * The LogControllerDtoAccountLoginLogListAccountLoginLogData model constructor.
     * @property {module:model/LogControllerDtoAccountLoginLogListAccountLoginLogData}
     */
    LogControllerDtoAccountLoginLogListAccountLoginLogData,

    /**
     * The LogControllerDtoAccountLoginLogListRequest model constructor.
     * @property {module:model/LogControllerDtoAccountLoginLogListRequest}
     */
    LogControllerDtoAccountLoginLogListRequest,

    /**
     * The LogControllerDtoAccountLoginLogListResponse model constructor.
     * @property {module:model/LogControllerDtoAccountLoginLogListResponse}
     */
    LogControllerDtoAccountLoginLogListResponse,

    /**
     * The LogControllerDtoAccountSessionLogListAccountSessionLogData model constructor.
     * @property {module:model/LogControllerDtoAccountSessionLogListAccountSessionLogData}
     */
    LogControllerDtoAccountSessionLogListAccountSessionLogData,

    /**
     * The LogControllerDtoAccountSessionLogListRequest model constructor.
     * @property {module:model/LogControllerDtoAccountSessionLogListRequest}
     */
    LogControllerDtoAccountSessionLogListRequest,

    /**
     * The LogControllerDtoAccountSessionLogListResponse model constructor.
     * @property {module:model/LogControllerDtoAccountSessionLogListResponse}
     */
    LogControllerDtoAccountSessionLogListResponse,

    /**
     * The LogControllerDtoBreedLogListBreedLogData model constructor.
     * @property {module:model/LogControllerDtoBreedLogListBreedLogData}
     */
    LogControllerDtoBreedLogListBreedLogData,

    /**
     * The LogControllerDtoBreedLogListRequest model constructor.
     * @property {module:model/LogControllerDtoBreedLogListRequest}
     */
    LogControllerDtoBreedLogListRequest,

    /**
     * The LogControllerDtoBreedLogListResponse model constructor.
     * @property {module:model/LogControllerDtoBreedLogListResponse}
     */
    LogControllerDtoBreedLogListResponse,

    /**
     * The LogControllerDtoCommonSafetyCodeLogListListData model constructor.
     * @property {module:model/LogControllerDtoCommonSafetyCodeLogListListData}
     */
    LogControllerDtoCommonSafetyCodeLogListListData,

    /**
     * The LogControllerDtoCommonSafetyCodeLogListRequest model constructor.
     * @property {module:model/LogControllerDtoCommonSafetyCodeLogListRequest}
     */
    LogControllerDtoCommonSafetyCodeLogListRequest,

    /**
     * The LogControllerDtoCommonSafetyCodeLogListResponse model constructor.
     * @property {module:model/LogControllerDtoCommonSafetyCodeLogListResponse}
     */
    LogControllerDtoCommonSafetyCodeLogListResponse,

    /**
     * The LogControllerDtoEvolveLogListRequest model constructor.
     * @property {module:model/LogControllerDtoEvolveLogListRequest}
     */
    LogControllerDtoEvolveLogListRequest,

    /**
     * The LogControllerDtoEvolveLogListResponse model constructor.
     * @property {module:model/LogControllerDtoEvolveLogListResponse}
     */
    LogControllerDtoEvolveLogListResponse,

    /**
     * The LogControllerDtoGamePlaySessionLogListGamePlaySessionLogData model constructor.
     * @property {module:model/LogControllerDtoGamePlaySessionLogListGamePlaySessionLogData}
     */
    LogControllerDtoGamePlaySessionLogListGamePlaySessionLogData,

    /**
     * The LogControllerDtoGamePlaySessionLogListRequest model constructor.
     * @property {module:model/LogControllerDtoGamePlaySessionLogListRequest}
     */
    LogControllerDtoGamePlaySessionLogListRequest,

    /**
     * The LogControllerDtoGamePlaySessionLogListResponse model constructor.
     * @property {module:model/LogControllerDtoGamePlaySessionLogListResponse}
     */
    LogControllerDtoGamePlaySessionLogListResponse,

    /**
     * The LogControllerDtoGearMiningLogListGearMiningLogData model constructor.
     * @property {module:model/LogControllerDtoGearMiningLogListGearMiningLogData}
     */
    LogControllerDtoGearMiningLogListGearMiningLogData,

    /**
     * The LogControllerDtoGearMiningLogListRequest model constructor.
     * @property {module:model/LogControllerDtoGearMiningLogListRequest}
     */
    LogControllerDtoGearMiningLogListRequest,

    /**
     * The LogControllerDtoGearMiningLogListResponse model constructor.
     * @property {module:model/LogControllerDtoGearMiningLogListResponse}
     */
    LogControllerDtoGearMiningLogListResponse,

    /**
     * The LogControllerDtoGemSocketUpdateLogListGemSocketUpdateLogData model constructor.
     * @property {module:model/LogControllerDtoGemSocketUpdateLogListGemSocketUpdateLogData}
     */
    LogControllerDtoGemSocketUpdateLogListGemSocketUpdateLogData,

    /**
     * The LogControllerDtoGemSocketUpdateLogListRequest model constructor.
     * @property {module:model/LogControllerDtoGemSocketUpdateLogListRequest}
     */
    LogControllerDtoGemSocketUpdateLogListRequest,

    /**
     * The LogControllerDtoGemSocketUpdateLogListResponse model constructor.
     * @property {module:model/LogControllerDtoGemSocketUpdateLogListResponse}
     */
    LogControllerDtoGemSocketUpdateLogListResponse,

    /**
     * The LogControllerDtoGoogleStorePurchaseLogListListData model constructor.
     * @property {module:model/LogControllerDtoGoogleStorePurchaseLogListListData}
     */
    LogControllerDtoGoogleStorePurchaseLogListListData,

    /**
     * The LogControllerDtoGoogleStorePurchaseLogListRequest model constructor.
     * @property {module:model/LogControllerDtoGoogleStorePurchaseLogListRequest}
     */
    LogControllerDtoGoogleStorePurchaseLogListRequest,

    /**
     * The LogControllerDtoGoogleStorePurchaseLogListResponse model constructor.
     * @property {module:model/LogControllerDtoGoogleStorePurchaseLogListResponse}
     */
    LogControllerDtoGoogleStorePurchaseLogListResponse,

    /**
     * The LogControllerDtoInventoryTransactionLogListInventoryTransactionLogData model constructor.
     * @property {module:model/LogControllerDtoInventoryTransactionLogListInventoryTransactionLogData}
     */
    LogControllerDtoInventoryTransactionLogListInventoryTransactionLogData,

    /**
     * The LogControllerDtoInventoryTransactionLogListRequest model constructor.
     * @property {module:model/LogControllerDtoInventoryTransactionLogListRequest}
     */
    LogControllerDtoInventoryTransactionLogListRequest,

    /**
     * The LogControllerDtoInventoryTransactionLogListResponse model constructor.
     * @property {module:model/LogControllerDtoInventoryTransactionLogListResponse}
     */
    LogControllerDtoInventoryTransactionLogListResponse,

    /**
     * The LogControllerDtoItemBoxOpenLogListListData model constructor.
     * @property {module:model/LogControllerDtoItemBoxOpenLogListListData}
     */
    LogControllerDtoItemBoxOpenLogListListData,

    /**
     * The LogControllerDtoItemBoxOpenLogListRequest model constructor.
     * @property {module:model/LogControllerDtoItemBoxOpenLogListRequest}
     */
    LogControllerDtoItemBoxOpenLogListRequest,

    /**
     * The LogControllerDtoItemBoxOpenLogListResponse model constructor.
     * @property {module:model/LogControllerDtoItemBoxOpenLogListResponse}
     */
    LogControllerDtoItemBoxOpenLogListResponse,

    /**
     * The LogControllerDtoItemShopPurchaseLogListListData model constructor.
     * @property {module:model/LogControllerDtoItemShopPurchaseLogListListData}
     */
    LogControllerDtoItemShopPurchaseLogListListData,

    /**
     * The LogControllerDtoItemShopPurchaseLogListRequest model constructor.
     * @property {module:model/LogControllerDtoItemShopPurchaseLogListRequest}
     */
    LogControllerDtoItemShopPurchaseLogListRequest,

    /**
     * The LogControllerDtoItemShopPurchaseLogListResponse model constructor.
     * @property {module:model/LogControllerDtoItemShopPurchaseLogListResponse}
     */
    LogControllerDtoItemShopPurchaseLogListResponse,

    /**
     * The LogControllerDtoItemTransactionLogListItemTransactionLogData model constructor.
     * @property {module:model/LogControllerDtoItemTransactionLogListItemTransactionLogData}
     */
    LogControllerDtoItemTransactionLogListItemTransactionLogData,

    /**
     * The LogControllerDtoItemTransactionLogListRequest model constructor.
     * @property {module:model/LogControllerDtoItemTransactionLogListRequest}
     */
    LogControllerDtoItemTransactionLogListRequest,

    /**
     * The LogControllerDtoItemTransactionLogListResponse model constructor.
     * @property {module:model/LogControllerDtoItemTransactionLogListResponse}
     */
    LogControllerDtoItemTransactionLogListResponse,

    /**
     * The LogControllerDtoLevelUpLogListLevelUpLogData model constructor.
     * @property {module:model/LogControllerDtoLevelUpLogListLevelUpLogData}
     */
    LogControllerDtoLevelUpLogListLevelUpLogData,

    /**
     * The LogControllerDtoLevelUpLogListRequest model constructor.
     * @property {module:model/LogControllerDtoLevelUpLogListRequest}
     */
    LogControllerDtoLevelUpLogListRequest,

    /**
     * The LogControllerDtoLevelUpLogListResponse model constructor.
     * @property {module:model/LogControllerDtoLevelUpLogListResponse}
     */
    LogControllerDtoLevelUpLogListResponse,

    /**
     * The LogControllerDtoMarketCarBoxTransactionLogListMarketCarBoxTransactionLogData model constructor.
     * @property {module:model/LogControllerDtoMarketCarBoxTransactionLogListMarketCarBoxTransactionLogData}
     */
    LogControllerDtoMarketCarBoxTransactionLogListMarketCarBoxTransactionLogData,

    /**
     * The LogControllerDtoMarketCarBoxTransactionLogListRequest model constructor.
     * @property {module:model/LogControllerDtoMarketCarBoxTransactionLogListRequest}
     */
    LogControllerDtoMarketCarBoxTransactionLogListRequest,

    /**
     * The LogControllerDtoMarketCarBoxTransactionLogListResponse model constructor.
     * @property {module:model/LogControllerDtoMarketCarBoxTransactionLogListResponse}
     */
    LogControllerDtoMarketCarBoxTransactionLogListResponse,

    /**
     * The LogControllerDtoMarketCarTransactionLogListMarketCarTransactionLogData model constructor.
     * @property {module:model/LogControllerDtoMarketCarTransactionLogListMarketCarTransactionLogData}
     */
    LogControllerDtoMarketCarTransactionLogListMarketCarTransactionLogData,

    /**
     * The LogControllerDtoMarketCarTransactionLogListRequest model constructor.
     * @property {module:model/LogControllerDtoMarketCarTransactionLogListRequest}
     */
    LogControllerDtoMarketCarTransactionLogListRequest,

    /**
     * The LogControllerDtoMarketCarTransactionLogListResponse model constructor.
     * @property {module:model/LogControllerDtoMarketCarTransactionLogListResponse}
     */
    LogControllerDtoMarketCarTransactionLogListResponse,

    /**
     * The LogControllerDtoMarketGemTransactionLogListRequest model constructor.
     * @property {module:model/LogControllerDtoMarketGemTransactionLogListRequest}
     */
    LogControllerDtoMarketGemTransactionLogListRequest,

    /**
     * The LogControllerDtoMarketGemTransactionLogListResponse model constructor.
     * @property {module:model/LogControllerDtoMarketGemTransactionLogListResponse}
     */
    LogControllerDtoMarketGemTransactionLogListResponse,

    /**
     * The LogControllerDtoMarketItemTransactionLogListRequest model constructor.
     * @property {module:model/LogControllerDtoMarketItemTransactionLogListRequest}
     */
    LogControllerDtoMarketItemTransactionLogListRequest,

    /**
     * The LogControllerDtoMarketItemTransactionLogListResponse model constructor.
     * @property {module:model/LogControllerDtoMarketItemTransactionLogListResponse}
     */
    LogControllerDtoMarketItemTransactionLogListResponse,

    /**
     * The LogControllerDtoMarketPilotTransactionLogListMarketPilotTransactionLogData model constructor.
     * @property {module:model/LogControllerDtoMarketPilotTransactionLogListMarketPilotTransactionLogData}
     */
    LogControllerDtoMarketPilotTransactionLogListMarketPilotTransactionLogData,

    /**
     * The LogControllerDtoMarketPilotTransactionLogListRequest model constructor.
     * @property {module:model/LogControllerDtoMarketPilotTransactionLogListRequest}
     */
    LogControllerDtoMarketPilotTransactionLogListRequest,

    /**
     * The LogControllerDtoMarketPilotTransactionLogListResponse model constructor.
     * @property {module:model/LogControllerDtoMarketPilotTransactionLogListResponse}
     */
    LogControllerDtoMarketPilotTransactionLogListResponse,

    /**
     * The LogControllerDtoMissionFreeLogListMissionFreeLogData model constructor.
     * @property {module:model/LogControllerDtoMissionFreeLogListMissionFreeLogData}
     */
    LogControllerDtoMissionFreeLogListMissionFreeLogData,

    /**
     * The LogControllerDtoMissionFreeLogListRequest model constructor.
     * @property {module:model/LogControllerDtoMissionFreeLogListRequest}
     */
    LogControllerDtoMissionFreeLogListRequest,

    /**
     * The LogControllerDtoMissionFreeLogListResponse model constructor.
     * @property {module:model/LogControllerDtoMissionFreeLogListResponse}
     */
    LogControllerDtoMissionFreeLogListResponse,

    /**
     * The LogControllerDtoNftDisassembleLogListNftDisassembleLogListData model constructor.
     * @property {module:model/LogControllerDtoNftDisassembleLogListNftDisassembleLogListData}
     */
    LogControllerDtoNftDisassembleLogListNftDisassembleLogListData,

    /**
     * The LogControllerDtoNftDisassembleLogListRequest model constructor.
     * @property {module:model/LogControllerDtoNftDisassembleLogListRequest}
     */
    LogControllerDtoNftDisassembleLogListRequest,

    /**
     * The LogControllerDtoNftDisassembleLogListResponse model constructor.
     * @property {module:model/LogControllerDtoNftDisassembleLogListResponse}
     */
    LogControllerDtoNftDisassembleLogListResponse,

    /**
     * The LogControllerDtoNftRepairLogListNftRepairLogData model constructor.
     * @property {module:model/LogControllerDtoNftRepairLogListNftRepairLogData}
     */
    LogControllerDtoNftRepairLogListNftRepairLogData,

    /**
     * The LogControllerDtoNftRepairLogListRequest model constructor.
     * @property {module:model/LogControllerDtoNftRepairLogListRequest}
     */
    LogControllerDtoNftRepairLogListRequest,

    /**
     * The LogControllerDtoNftRepairLogListResponse model constructor.
     * @property {module:model/LogControllerDtoNftRepairLogListResponse}
     */
    LogControllerDtoNftRepairLogListResponse,

    /**
     * The LogControllerDtoNftRestoreLogListNftRestoreLogData model constructor.
     * @property {module:model/LogControllerDtoNftRestoreLogListNftRestoreLogData}
     */
    LogControllerDtoNftRestoreLogListNftRestoreLogData,

    /**
     * The LogControllerDtoNftRestoreLogListRequest model constructor.
     * @property {module:model/LogControllerDtoNftRestoreLogListRequest}
     */
    LogControllerDtoNftRestoreLogListRequest,

    /**
     * The LogControllerDtoNftRestoreLogListResponse model constructor.
     * @property {module:model/LogControllerDtoNftRestoreLogListResponse}
     */
    LogControllerDtoNftRestoreLogListResponse,

    /**
     * The LogControllerDtoNftStoredPowersLogListNftStoredPowersLogListData model constructor.
     * @property {module:model/LogControllerDtoNftStoredPowersLogListNftStoredPowersLogListData}
     */
    LogControllerDtoNftStoredPowersLogListNftStoredPowersLogListData,

    /**
     * The LogControllerDtoNftStoredPowersLogListRequest model constructor.
     * @property {module:model/LogControllerDtoNftStoredPowersLogListRequest}
     */
    LogControllerDtoNftStoredPowersLogListRequest,

    /**
     * The LogControllerDtoNftStoredPowersLogListResponse model constructor.
     * @property {module:model/LogControllerDtoNftStoredPowersLogListResponse}
     */
    LogControllerDtoNftStoredPowersLogListResponse,

    /**
     * The LogControllerDtoNftTransactionLogListNftTransactionLogData model constructor.
     * @property {module:model/LogControllerDtoNftTransactionLogListNftTransactionLogData}
     */
    LogControllerDtoNftTransactionLogListNftTransactionLogData,

    /**
     * The LogControllerDtoNftTransactionLogListRequest model constructor.
     * @property {module:model/LogControllerDtoNftTransactionLogListRequest}
     */
    LogControllerDtoNftTransactionLogListRequest,

    /**
     * The LogControllerDtoNftTransactionLogListResponse model constructor.
     * @property {module:model/LogControllerDtoNftTransactionLogListResponse}
     */
    LogControllerDtoNftTransactionLogListResponse,

    /**
     * The LogControllerDtoNicknameChangeLogListNicknameChangeLogData model constructor.
     * @property {module:model/LogControllerDtoNicknameChangeLogListNicknameChangeLogData}
     */
    LogControllerDtoNicknameChangeLogListNicknameChangeLogData,

    /**
     * The LogControllerDtoNicknameChangeLogListRequest model constructor.
     * @property {module:model/LogControllerDtoNicknameChangeLogListRequest}
     */
    LogControllerDtoNicknameChangeLogListRequest,

    /**
     * The LogControllerDtoNicknameChangeLogListResponse model constructor.
     * @property {module:model/LogControllerDtoNicknameChangeLogListResponse}
     */
    LogControllerDtoNicknameChangeLogListResponse,

    /**
     * The LogControllerDtoPilotDisassembleLogListPilotDisassembleLogData model constructor.
     * @property {module:model/LogControllerDtoPilotDisassembleLogListPilotDisassembleLogData}
     */
    LogControllerDtoPilotDisassembleLogListPilotDisassembleLogData,

    /**
     * The LogControllerDtoPilotDisassembleLogListRequest model constructor.
     * @property {module:model/LogControllerDtoPilotDisassembleLogListRequest}
     */
    LogControllerDtoPilotDisassembleLogListRequest,

    /**
     * The LogControllerDtoPilotDisassembleLogListResponse model constructor.
     * @property {module:model/LogControllerDtoPilotDisassembleLogListResponse}
     */
    LogControllerDtoPilotDisassembleLogListResponse,

    /**
     * The LogControllerDtoPilotEquipLogListPilotEquipLogData model constructor.
     * @property {module:model/LogControllerDtoPilotEquipLogListPilotEquipLogData}
     */
    LogControllerDtoPilotEquipLogListPilotEquipLogData,

    /**
     * The LogControllerDtoPilotEquipLogListRequest model constructor.
     * @property {module:model/LogControllerDtoPilotEquipLogListRequest}
     */
    LogControllerDtoPilotEquipLogListRequest,

    /**
     * The LogControllerDtoPilotEquipLogListResponse model constructor.
     * @property {module:model/LogControllerDtoPilotEquipLogListResponse}
     */
    LogControllerDtoPilotEquipLogListResponse,

    /**
     * The LogControllerDtoPilotPromotionLogListPilotPromotionLogData model constructor.
     * @property {module:model/LogControllerDtoPilotPromotionLogListPilotPromotionLogData}
     */
    LogControllerDtoPilotPromotionLogListPilotPromotionLogData,

    /**
     * The LogControllerDtoPilotPromotionLogListRequest model constructor.
     * @property {module:model/LogControllerDtoPilotPromotionLogListRequest}
     */
    LogControllerDtoPilotPromotionLogListRequest,

    /**
     * The LogControllerDtoPilotPromotionLogListResponse model constructor.
     * @property {module:model/LogControllerDtoPilotPromotionLogListResponse}
     */
    LogControllerDtoPilotPromotionLogListResponse,

    /**
     * The LogControllerDtoPilotSkillChangeLogListPilotSkillChangeLogData model constructor.
     * @property {module:model/LogControllerDtoPilotSkillChangeLogListPilotSkillChangeLogData}
     */
    LogControllerDtoPilotSkillChangeLogListPilotSkillChangeLogData,

    /**
     * The LogControllerDtoPilotSkillChangeLogListRequest model constructor.
     * @property {module:model/LogControllerDtoPilotSkillChangeLogListRequest}
     */
    LogControllerDtoPilotSkillChangeLogListRequest,

    /**
     * The LogControllerDtoPilotSkillChangeLogListResponse model constructor.
     * @property {module:model/LogControllerDtoPilotSkillChangeLogListResponse}
     */
    LogControllerDtoPilotSkillChangeLogListResponse,

    /**
     * The LogControllerDtoPowerChargeLogListPowerChargeLogData model constructor.
     * @property {module:model/LogControllerDtoPowerChargeLogListPowerChargeLogData}
     */
    LogControllerDtoPowerChargeLogListPowerChargeLogData,

    /**
     * The LogControllerDtoPowerChargeLogListRequest model constructor.
     * @property {module:model/LogControllerDtoPowerChargeLogListRequest}
     */
    LogControllerDtoPowerChargeLogListRequest,

    /**
     * The LogControllerDtoPowerChargeLogListResponse model constructor.
     * @property {module:model/LogControllerDtoPowerChargeLogListResponse}
     */
    LogControllerDtoPowerChargeLogListResponse,

    /**
     * The LogControllerDtoResetStatsLogListRequest model constructor.
     * @property {module:model/LogControllerDtoResetStatsLogListRequest}
     */
    LogControllerDtoResetStatsLogListRequest,

    /**
     * The LogControllerDtoResetStatsLogListResetStatsLogData model constructor.
     * @property {module:model/LogControllerDtoResetStatsLogListResetStatsLogData}
     */
    LogControllerDtoResetStatsLogListResetStatsLogData,

    /**
     * The LogControllerDtoResetStatsLogListResponse model constructor.
     * @property {module:model/LogControllerDtoResetStatsLogListResponse}
     */
    LogControllerDtoResetStatsLogListResponse,

    /**
     * The LogControllerDtoRollRandomGemSocketsLogListRequest model constructor.
     * @property {module:model/LogControllerDtoRollRandomGemSocketsLogListRequest}
     */
    LogControllerDtoRollRandomGemSocketsLogListRequest,

    /**
     * The LogControllerDtoRollRandomGemSocketsLogListResponse model constructor.
     * @property {module:model/LogControllerDtoRollRandomGemSocketsLogListResponse}
     */
    LogControllerDtoRollRandomGemSocketsLogListResponse,

    /**
     * The LogControllerDtoRollRandomGemSocketsLogListRollRandomGemSocketsLogData model constructor.
     * @property {module:model/LogControllerDtoRollRandomGemSocketsLogListRollRandomGemSocketsLogData}
     */
    LogControllerDtoRollRandomGemSocketsLogListRollRandomGemSocketsLogData,

    /**
     * The LogControllerDtoSpecialBoxLogListRequest model constructor.
     * @property {module:model/LogControllerDtoSpecialBoxLogListRequest}
     */
    LogControllerDtoSpecialBoxLogListRequest,

    /**
     * The LogControllerDtoSpecialBoxLogListResponse model constructor.
     * @property {module:model/LogControllerDtoSpecialBoxLogListResponse}
     */
    LogControllerDtoSpecialBoxLogListResponse,

    /**
     * The LogControllerDtoSpecialBoxLogListSpecialBoxLogData model constructor.
     * @property {module:model/LogControllerDtoSpecialBoxLogListSpecialBoxLogData}
     */
    LogControllerDtoSpecialBoxLogListSpecialBoxLogData,

    /**
     * The LogControllerDtoTransactionAttemptLogListRequest model constructor.
     * @property {module:model/LogControllerDtoTransactionAttemptLogListRequest}
     */
    LogControllerDtoTransactionAttemptLogListRequest,

    /**
     * The LogControllerDtoTransactionAttemptLogListResponse model constructor.
     * @property {module:model/LogControllerDtoTransactionAttemptLogListResponse}
     */
    LogControllerDtoTransactionAttemptLogListResponse,

    /**
     * The LogControllerDtoTransactionAttemptLogListTransactionAttemptLogListData model constructor.
     * @property {module:model/LogControllerDtoTransactionAttemptLogListTransactionAttemptLogListData}
     */
    LogControllerDtoTransactionAttemptLogListTransactionAttemptLogListData,

    /**
     * The LogControllerDtoWalletConnectionLogListRequest model constructor.
     * @property {module:model/LogControllerDtoWalletConnectionLogListRequest}
     */
    LogControllerDtoWalletConnectionLogListRequest,

    /**
     * The LogControllerDtoWalletConnectionLogListResponse model constructor.
     * @property {module:model/LogControllerDtoWalletConnectionLogListResponse}
     */
    LogControllerDtoWalletConnectionLogListResponse,

    /**
     * The LogControllerDtoWalletConnectionLogListWalletConnectionLogListData model constructor.
     * @property {module:model/LogControllerDtoWalletConnectionLogListWalletConnectionLogListData}
     */
    LogControllerDtoWalletConnectionLogListWalletConnectionLogListData,

    /**
     * The LogControllerDtoWalletTransactionLogListRequest model constructor.
     * @property {module:model/LogControllerDtoWalletTransactionLogListRequest}
     */
    LogControllerDtoWalletTransactionLogListRequest,

    /**
     * The LogControllerDtoWalletTransactionLogListResponse model constructor.
     * @property {module:model/LogControllerDtoWalletTransactionLogListResponse}
     */
    LogControllerDtoWalletTransactionLogListResponse,

    /**
     * The LogControllerDtoWalletTransactionLogListWalletTransactionLogData model constructor.
     * @property {module:model/LogControllerDtoWalletTransactionLogListWalletTransactionLogData}
     */
    LogControllerDtoWalletTransactionLogListWalletTransactionLogData,

    /**
     * The ManagerAccountControllerDtoCategoryListResponse model constructor.
     * @property {module:model/ManagerAccountControllerDtoCategoryListResponse}
     */
    ManagerAccountControllerDtoCategoryListResponse,

    /**
     * The ManagerAccountControllerDtoFindPasswordRequest model constructor.
     * @property {module:model/ManagerAccountControllerDtoFindPasswordRequest}
     */
    ManagerAccountControllerDtoFindPasswordRequest,

    /**
     * The ManagerAccountControllerDtoLoginInfoResponse model constructor.
     * @property {module:model/ManagerAccountControllerDtoLoginInfoResponse}
     */
    ManagerAccountControllerDtoLoginInfoResponse,

    /**
     * The ManagerAccountControllerDtoLoginRequest model constructor.
     * @property {module:model/ManagerAccountControllerDtoLoginRequest}
     */
    ManagerAccountControllerDtoLoginRequest,

    /**
     * The ManagerAccountControllerDtoLoginResponse model constructor.
     * @property {module:model/ManagerAccountControllerDtoLoginResponse}
     */
    ManagerAccountControllerDtoLoginResponse,

    /**
     * The ManagerAccountControllerDtoLoginTwoFaAuthRequest model constructor.
     * @property {module:model/ManagerAccountControllerDtoLoginTwoFaAuthRequest}
     */
    ManagerAccountControllerDtoLoginTwoFaAuthRequest,

    /**
     * The ManagerAccountControllerDtoLoginTwoFaAuthResponse model constructor.
     * @property {module:model/ManagerAccountControllerDtoLoginTwoFaAuthResponse}
     */
    ManagerAccountControllerDtoLoginTwoFaAuthResponse,

    /**
     * The ManagerAccountControllerDtoMyInfoResponse model constructor.
     * @property {module:model/ManagerAccountControllerDtoMyInfoResponse}
     */
    ManagerAccountControllerDtoMyInfoResponse,

    /**
     * The ManagerAccountControllerDtoMyNameChangeRequest model constructor.
     * @property {module:model/ManagerAccountControllerDtoMyNameChangeRequest}
     */
    ManagerAccountControllerDtoMyNameChangeRequest,

    /**
     * The ManagerAccountControllerDtoMyNameChangeResponse model constructor.
     * @property {module:model/ManagerAccountControllerDtoMyNameChangeResponse}
     */
    ManagerAccountControllerDtoMyNameChangeResponse,

    /**
     * The ManagerAccountControllerDtoMyPasswordChangeRequest model constructor.
     * @property {module:model/ManagerAccountControllerDtoMyPasswordChangeRequest}
     */
    ManagerAccountControllerDtoMyPasswordChangeRequest,

    /**
     * The ManagerAccountControllerDtoMyRemoveTwoFactorRequest model constructor.
     * @property {module:model/ManagerAccountControllerDtoMyRemoveTwoFactorRequest}
     */
    ManagerAccountControllerDtoMyRemoveTwoFactorRequest,

    /**
     * The ManagerAccountControllerDtoNotificationListResponse model constructor.
     * @property {module:model/ManagerAccountControllerDtoNotificationListResponse}
     */
    ManagerAccountControllerDtoNotificationListResponse,

    /**
     * The ManagerAccountControllerDtoNotificationTokenCreateRequest model constructor.
     * @property {module:model/ManagerAccountControllerDtoNotificationTokenCreateRequest}
     */
    ManagerAccountControllerDtoNotificationTokenCreateRequest,

    /**
     * The ManagerAccountControllerDtoNotificationsMarkingAsReadRequest model constructor.
     * @property {module:model/ManagerAccountControllerDtoNotificationsMarkingAsReadRequest}
     */
    ManagerAccountControllerDtoNotificationsMarkingAsReadRequest,

    /**
     * The ManagerAccountControllerDtoNotificationsRemoveRequest model constructor.
     * @property {module:model/ManagerAccountControllerDtoNotificationsRemoveRequest}
     */
    ManagerAccountControllerDtoNotificationsRemoveRequest,

    /**
     * The ManagerControllerDtoAuthorizationGroupListResponse model constructor.
     * @property {module:model/ManagerControllerDtoAuthorizationGroupListResponse}
     */
    ManagerControllerDtoAuthorizationGroupListResponse,

    /**
     * The ManagerControllerDtoCreateAccountRequest model constructor.
     * @property {module:model/ManagerControllerDtoCreateAccountRequest}
     */
    ManagerControllerDtoCreateAccountRequest,

    /**
     * The ManagerControllerDtoCreateAccountResponse model constructor.
     * @property {module:model/ManagerControllerDtoCreateAccountResponse}
     */
    ManagerControllerDtoCreateAccountResponse,

    /**
     * The ManagerControllerDtoDepartmentListResponse model constructor.
     * @property {module:model/ManagerControllerDtoDepartmentListResponse}
     */
    ManagerControllerDtoDepartmentListResponse,

    /**
     * The ManagerControllerDtoEmailCheckRequest model constructor.
     * @property {module:model/ManagerControllerDtoEmailCheckRequest}
     */
    ManagerControllerDtoEmailCheckRequest,

    /**
     * The ManagerControllerDtoEmailCheckResponse model constructor.
     * @property {module:model/ManagerControllerDtoEmailCheckResponse}
     */
    ManagerControllerDtoEmailCheckResponse,

    /**
     * The ManagerControllerDtoManagerInfoUpdateRequest model constructor.
     * @property {module:model/ManagerControllerDtoManagerInfoUpdateRequest}
     */
    ManagerControllerDtoManagerInfoUpdateRequest,

    /**
     * The ManagerControllerDtoManagerListRequest model constructor.
     * @property {module:model/ManagerControllerDtoManagerListRequest}
     */
    ManagerControllerDtoManagerListRequest,

    /**
     * The ManagerControllerDtoManagerListResponse model constructor.
     * @property {module:model/ManagerControllerDtoManagerListResponse}
     */
    ManagerControllerDtoManagerListResponse,

    /**
     * The ManagerControllerDtoManagerLoginLogListRequest model constructor.
     * @property {module:model/ManagerControllerDtoManagerLoginLogListRequest}
     */
    ManagerControllerDtoManagerLoginLogListRequest,

    /**
     * The ManagerControllerDtoManagerLoginLogListResponse model constructor.
     * @property {module:model/ManagerControllerDtoManagerLoginLogListResponse}
     */
    ManagerControllerDtoManagerLoginLogListResponse,

    /**
     * The ManagerControllerDtoManagerSecedeRequest model constructor.
     * @property {module:model/ManagerControllerDtoManagerSecedeRequest}
     */
    ManagerControllerDtoManagerSecedeRequest,

    /**
     * The ManagerControllerDtoManagerTerminateSessionRequest model constructor.
     * @property {module:model/ManagerControllerDtoManagerTerminateSessionRequest}
     */
    ManagerControllerDtoManagerTerminateSessionRequest,

    /**
     * The ManagerControllerDtoManagerTwoFactorLogListRequest model constructor.
     * @property {module:model/ManagerControllerDtoManagerTwoFactorLogListRequest}
     */
    ManagerControllerDtoManagerTwoFactorLogListRequest,

    /**
     * The ManagerControllerDtoManagerTwoFactorLogListResponse model constructor.
     * @property {module:model/ManagerControllerDtoManagerTwoFactorLogListResponse}
     */
    ManagerControllerDtoManagerTwoFactorLogListResponse,

    /**
     * The ManagerControllerDtoManagerViewRequest model constructor.
     * @property {module:model/ManagerControllerDtoManagerViewRequest}
     */
    ManagerControllerDtoManagerViewRequest,

    /**
     * The ManagerControllerDtoManagerViewResponse model constructor.
     * @property {module:model/ManagerControllerDtoManagerViewResponse}
     */
    ManagerControllerDtoManagerViewResponse,

    /**
     * The ManagerControllerDtoManagerWorkedLogListRequest model constructor.
     * @property {module:model/ManagerControllerDtoManagerWorkedLogListRequest}
     */
    ManagerControllerDtoManagerWorkedLogListRequest,

    /**
     * The ManagerControllerDtoManagerWorkedLogListResponse model constructor.
     * @property {module:model/ManagerControllerDtoManagerWorkedLogListResponse}
     */
    ManagerControllerDtoManagerWorkedLogListResponse,

    /**
     * The ManagerControllerDtoRemoveTwoFactorRequest model constructor.
     * @property {module:model/ManagerControllerDtoRemoveTwoFactorRequest}
     */
    ManagerControllerDtoRemoveTwoFactorRequest,

    /**
     * The ManagerControllerDtoRndChangePasswordRequest model constructor.
     * @property {module:model/ManagerControllerDtoRndChangePasswordRequest}
     */
    ManagerControllerDtoRndChangePasswordRequest,

    /**
     * The ManagerData model constructor.
     * @property {module:model/ManagerData}
     */
    ManagerData,

    /**
     * The ManagerLoginLogData model constructor.
     * @property {module:model/ManagerLoginLogData}
     */
    ManagerLoginLogData,

    /**
     * The ManagerTwoFactorLogData model constructor.
     * @property {module:model/ManagerTwoFactorLogData}
     */
    ManagerTwoFactorLogData,

    /**
     * The ManagerWorkedLogData model constructor.
     * @property {module:model/ManagerWorkedLogData}
     */
    ManagerWorkedLogData,

    /**
     * The MarketGoogleStoreProductInfoRequest model constructor.
     * @property {module:model/MarketGoogleStoreProductInfoRequest}
     */
    MarketGoogleStoreProductInfoRequest,

    /**
     * The MarketGoogleStoreProductInfoResponse model constructor.
     * @property {module:model/MarketGoogleStoreProductInfoResponse}
     */
    MarketGoogleStoreProductInfoResponse,

    /**
     * The MarketGoogleStoreProductListListData model constructor.
     * @property {module:model/MarketGoogleStoreProductListListData}
     */
    MarketGoogleStoreProductListListData,

    /**
     * The MarketGoogleStoreProductListRequest model constructor.
     * @property {module:model/MarketGoogleStoreProductListRequest}
     */
    MarketGoogleStoreProductListRequest,

    /**
     * The MarketGoogleStoreProductListResponse model constructor.
     * @property {module:model/MarketGoogleStoreProductListResponse}
     */
    MarketGoogleStoreProductListResponse,

    /**
     * The MarketGoogleStoreProductSortUpdateRequest model constructor.
     * @property {module:model/MarketGoogleStoreProductSortUpdateRequest}
     */
    MarketGoogleStoreProductSortUpdateRequest,

    /**
     * The MarketGoogleStoreProductUpsertRequest model constructor.
     * @property {module:model/MarketGoogleStoreProductUpsertRequest}
     */
    MarketGoogleStoreProductUpsertRequest,

    /**
     * The MarketItemShopInfoRequest model constructor.
     * @property {module:model/MarketItemShopInfoRequest}
     */
    MarketItemShopInfoRequest,

    /**
     * The MarketItemShopInfoResponse model constructor.
     * @property {module:model/MarketItemShopInfoResponse}
     */
    MarketItemShopInfoResponse,

    /**
     * The MarketItemShopListListData model constructor.
     * @property {module:model/MarketItemShopListListData}
     */
    MarketItemShopListListData,

    /**
     * The MarketItemShopListRequest model constructor.
     * @property {module:model/MarketItemShopListRequest}
     */
    MarketItemShopListRequest,

    /**
     * The MarketItemShopListResponse model constructor.
     * @property {module:model/MarketItemShopListResponse}
     */
    MarketItemShopListResponse,

    /**
     * The MarketItemShopSortUpdateRequest model constructor.
     * @property {module:model/MarketItemShopSortUpdateRequest}
     */
    MarketItemShopSortUpdateRequest,

    /**
     * The MarketItemShopUpsertRequest model constructor.
     * @property {module:model/MarketItemShopUpsertRequest}
     */
    MarketItemShopUpsertRequest,

    /**
     * The MarketItemTransactionLogData model constructor.
     * @property {module:model/MarketItemTransactionLogData}
     */
    MarketItemTransactionLogData,

    /**
     * The MarketStatus model constructor.
     * @property {module:model/MarketStatus}
     */
    MarketStatus,

    /**
     * The Material model constructor.
     * @property {module:model/Material}
     */
    Material,

    /**
     * The MaterialProperty model constructor.
     * @property {module:model/MaterialProperty}
     */
    MaterialProperty,

    /**
     * The MaterialType model constructor.
     * @property {module:model/MaterialType}
     */
    MaterialType,

    /**
     * The MissionControllerDtoBasicAccountInfoListBasicAccountInfoListData model constructor.
     * @property {module:model/MissionControllerDtoBasicAccountInfoListBasicAccountInfoListData}
     */
    MissionControllerDtoBasicAccountInfoListBasicAccountInfoListData,

    /**
     * The MissionControllerDtoBasicAccountInfoListRequest model constructor.
     * @property {module:model/MissionControllerDtoBasicAccountInfoListRequest}
     */
    MissionControllerDtoBasicAccountInfoListRequest,

    /**
     * The MissionControllerDtoBasicAccountInfoListResponse model constructor.
     * @property {module:model/MissionControllerDtoBasicAccountInfoListResponse}
     */
    MissionControllerDtoBasicAccountInfoListResponse,

    /**
     * The MissionControllerDtoBasicAccountPointLogListBasicAccountPointLogListData model constructor.
     * @property {module:model/MissionControllerDtoBasicAccountPointLogListBasicAccountPointLogListData}
     */
    MissionControllerDtoBasicAccountPointLogListBasicAccountPointLogListData,

    /**
     * The MissionControllerDtoBasicAccountPointLogListRequest model constructor.
     * @property {module:model/MissionControllerDtoBasicAccountPointLogListRequest}
     */
    MissionControllerDtoBasicAccountPointLogListRequest,

    /**
     * The MissionControllerDtoBasicAccountPointLogListResponse model constructor.
     * @property {module:model/MissionControllerDtoBasicAccountPointLogListResponse}
     */
    MissionControllerDtoBasicAccountPointLogListResponse,

    /**
     * The MissionControllerDtoBasicGradeRewardLogListBasicGradeRewardLogListData model constructor.
     * @property {module:model/MissionControllerDtoBasicGradeRewardLogListBasicGradeRewardLogListData}
     */
    MissionControllerDtoBasicGradeRewardLogListBasicGradeRewardLogListData,

    /**
     * The MissionControllerDtoBasicGradeRewardLogListRequest model constructor.
     * @property {module:model/MissionControllerDtoBasicGradeRewardLogListRequest}
     */
    MissionControllerDtoBasicGradeRewardLogListRequest,

    /**
     * The MissionControllerDtoBasicGradeRewardLogListResponse model constructor.
     * @property {module:model/MissionControllerDtoBasicGradeRewardLogListResponse}
     */
    MissionControllerDtoBasicGradeRewardLogListResponse,

    /**
     * The MissionControllerDtoBasicInvitedUsersListBasicInvitedUsersListData model constructor.
     * @property {module:model/MissionControllerDtoBasicInvitedUsersListBasicInvitedUsersListData}
     */
    MissionControllerDtoBasicInvitedUsersListBasicInvitedUsersListData,

    /**
     * The MissionControllerDtoBasicInvitedUsersListRequest model constructor.
     * @property {module:model/MissionControllerDtoBasicInvitedUsersListRequest}
     */
    MissionControllerDtoBasicInvitedUsersListRequest,

    /**
     * The MissionControllerDtoBasicInvitedUsersListResponse model constructor.
     * @property {module:model/MissionControllerDtoBasicInvitedUsersListResponse}
     */
    MissionControllerDtoBasicInvitedUsersListResponse,

    /**
     * The MissionControllerDtoMissionFreeInfoCreateRequest model constructor.
     * @property {module:model/MissionControllerDtoMissionFreeInfoCreateRequest}
     */
    MissionControllerDtoMissionFreeInfoCreateRequest,

    /**
     * The MissionControllerDtoMissionFreeInfoDetailRequest model constructor.
     * @property {module:model/MissionControllerDtoMissionFreeInfoDetailRequest}
     */
    MissionControllerDtoMissionFreeInfoDetailRequest,

    /**
     * The MissionControllerDtoMissionFreeInfoDetailResponse model constructor.
     * @property {module:model/MissionControllerDtoMissionFreeInfoDetailResponse}
     */
    MissionControllerDtoMissionFreeInfoDetailResponse,

    /**
     * The MissionControllerDtoMissionFreeInfoListBasicMissionFreeInfo model constructor.
     * @property {module:model/MissionControllerDtoMissionFreeInfoListBasicMissionFreeInfo}
     */
    MissionControllerDtoMissionFreeInfoListBasicMissionFreeInfo,

    /**
     * The MissionControllerDtoMissionFreeInfoListRequest model constructor.
     * @property {module:model/MissionControllerDtoMissionFreeInfoListRequest}
     */
    MissionControllerDtoMissionFreeInfoListRequest,

    /**
     * The MissionControllerDtoMissionFreeInfoListResponse model constructor.
     * @property {module:model/MissionControllerDtoMissionFreeInfoListResponse}
     */
    MissionControllerDtoMissionFreeInfoListResponse,

    /**
     * The MissionControllerDtoMissionFreeInfoUpdateRequest model constructor.
     * @property {module:model/MissionControllerDtoMissionFreeInfoUpdateRequest}
     */
    MissionControllerDtoMissionFreeInfoUpdateRequest,

    /**
     * The MnGnbData model constructor.
     * @property {module:model/MnGnbData}
     */
    MnGnbData,

    /**
     * The MnLnbData model constructor.
     * @property {module:model/MnLnbData}
     */
    MnLnbData,

    /**
     * The MnSubLnbData model constructor.
     * @property {module:model/MnSubLnbData}
     */
    MnSubLnbData,

    /**
     * The MonitoringControllerDtoGearNftListGearNftData model constructor.
     * @property {module:model/MonitoringControllerDtoGearNftListGearNftData}
     */
    MonitoringControllerDtoGearNftListGearNftData,

    /**
     * The MonitoringControllerDtoGearNftListRequest model constructor.
     * @property {module:model/MonitoringControllerDtoGearNftListRequest}
     */
    MonitoringControllerDtoGearNftListRequest,

    /**
     * The MonitoringControllerDtoGearNftListResponse model constructor.
     * @property {module:model/MonitoringControllerDtoGearNftListResponse}
     */
    MonitoringControllerDtoGearNftListResponse,

    /**
     * The MonitoringControllerDtoNftBoxListNftBoxData model constructor.
     * @property {module:model/MonitoringControllerDtoNftBoxListNftBoxData}
     */
    MonitoringControllerDtoNftBoxListNftBoxData,

    /**
     * The MonitoringControllerDtoNftBoxListRequest model constructor.
     * @property {module:model/MonitoringControllerDtoNftBoxListRequest}
     */
    MonitoringControllerDtoNftBoxListRequest,

    /**
     * The MonitoringControllerDtoNftBoxListResponse model constructor.
     * @property {module:model/MonitoringControllerDtoNftBoxListResponse}
     */
    MonitoringControllerDtoNftBoxListResponse,

    /**
     * The MonitoringControllerDtoNftCarListNftCarData model constructor.
     * @property {module:model/MonitoringControllerDtoNftCarListNftCarData}
     */
    MonitoringControllerDtoNftCarListNftCarData,

    /**
     * The MonitoringControllerDtoNftCarListRequest model constructor.
     * @property {module:model/MonitoringControllerDtoNftCarListRequest}
     */
    MonitoringControllerDtoNftCarListRequest,

    /**
     * The MonitoringControllerDtoNftCarListResponse model constructor.
     * @property {module:model/MonitoringControllerDtoNftCarListResponse}
     */
    MonitoringControllerDtoNftCarListResponse,

    /**
     * The MonitoringControllerDtoPilotNftListRequest model constructor.
     * @property {module:model/MonitoringControllerDtoPilotNftListRequest}
     */
    MonitoringControllerDtoPilotNftListRequest,

    /**
     * The MonitoringControllerDtoPilotNftListResponse model constructor.
     * @property {module:model/MonitoringControllerDtoPilotNftListResponse}
     */
    MonitoringControllerDtoPilotNftListResponse,

    /**
     * The MonitoringControllerDtoWalletListRequest model constructor.
     * @property {module:model/MonitoringControllerDtoWalletListRequest}
     */
    MonitoringControllerDtoWalletListRequest,

    /**
     * The MonitoringControllerDtoWalletListResponse model constructor.
     * @property {module:model/MonitoringControllerDtoWalletListResponse}
     */
    MonitoringControllerDtoWalletListResponse,

    /**
     * The MonitoringControllerDtoWalletListWalletData model constructor.
     * @property {module:model/MonitoringControllerDtoWalletListWalletData}
     */
    MonitoringControllerDtoWalletListWalletData,

    /**
     * The NftBoxGrade model constructor.
     * @property {module:model/NftBoxGrade}
     */
    NftBoxGrade,

    /**
     * The NftBoxType model constructor.
     * @property {module:model/NftBoxType}
     */
    NftBoxType,

    /**
     * The NftControllerDtoNftGenerateCreateRequest model constructor.
     * @property {module:model/NftControllerDtoNftGenerateCreateRequest}
     */
    NftControllerDtoNftGenerateCreateRequest,

    /**
     * The NftControllerDtoNftGenerateDetailRequest model constructor.
     * @property {module:model/NftControllerDtoNftGenerateDetailRequest}
     */
    NftControllerDtoNftGenerateDetailRequest,

    /**
     * The NftControllerDtoNftGenerateDetailResponse model constructor.
     * @property {module:model/NftControllerDtoNftGenerateDetailResponse}
     */
    NftControllerDtoNftGenerateDetailResponse,

    /**
     * The NftControllerDtoNftGenerateItemCreateRequest model constructor.
     * @property {module:model/NftControllerDtoNftGenerateItemCreateRequest}
     */
    NftControllerDtoNftGenerateItemCreateRequest,

    /**
     * The NftControllerDtoNftGenerateItemListRequest model constructor.
     * @property {module:model/NftControllerDtoNftGenerateItemListRequest}
     */
    NftControllerDtoNftGenerateItemListRequest,

    /**
     * The NftControllerDtoNftGenerateItemListResponse model constructor.
     * @property {module:model/NftControllerDtoNftGenerateItemListResponse}
     */
    NftControllerDtoNftGenerateItemListResponse,

    /**
     * The NftControllerDtoNftGenerateItemRemoveRequest model constructor.
     * @property {module:model/NftControllerDtoNftGenerateItemRemoveRequest}
     */
    NftControllerDtoNftGenerateItemRemoveRequest,

    /**
     * The NftControllerDtoNftGenerateListRequest model constructor.
     * @property {module:model/NftControllerDtoNftGenerateListRequest}
     */
    NftControllerDtoNftGenerateListRequest,

    /**
     * The NftControllerDtoNftGenerateListResponse model constructor.
     * @property {module:model/NftControllerDtoNftGenerateListResponse}
     */
    NftControllerDtoNftGenerateListResponse,

    /**
     * The NftControllerDtoNftGenerateRemoveRequest model constructor.
     * @property {module:model/NftControllerDtoNftGenerateRemoveRequest}
     */
    NftControllerDtoNftGenerateRemoveRequest,

    /**
     * The NftControllerDtoNftGenerateStartCreatingRequest model constructor.
     * @property {module:model/NftControllerDtoNftGenerateStartCreatingRequest}
     */
    NftControllerDtoNftGenerateStartCreatingRequest,

    /**
     * The NftGenerateData model constructor.
     * @property {module:model/NftGenerateData}
     */
    NftGenerateData,

    /**
     * The NftGenerateModel model constructor.
     * @property {module:model/NftGenerateModel}
     */
    NftGenerateModel,

    /**
     * The NftGeneratePublicData model constructor.
     * @property {module:model/NftGeneratePublicData}
     */
    NftGeneratePublicData,

    /**
     * The NftGenerateType model constructor.
     * @property {module:model/NftGenerateType}
     */
    NftGenerateType,

    /**
     * The NftGeneratorControllerDtoAddNftKeyIndexRequest model constructor.
     * @property {module:model/NftGeneratorControllerDtoAddNftKeyIndexRequest}
     */
    NftGeneratorControllerDtoAddNftKeyIndexRequest,

    /**
     * The NftGeneratorControllerDtoAddNftUidIndexRequest model constructor.
     * @property {module:model/NftGeneratorControllerDtoAddNftUidIndexRequest}
     */
    NftGeneratorControllerDtoAddNftUidIndexRequest,

    /**
     * The NftGeneratorControllerDtoNftBurnRequest model constructor.
     * @property {module:model/NftGeneratorControllerDtoNftBurnRequest}
     */
    NftGeneratorControllerDtoNftBurnRequest,

    /**
     * The NftGeneratorControllerDtoNftGenerateRequest model constructor.
     * @property {module:model/NftGeneratorControllerDtoNftGenerateRequest}
     */
    NftGeneratorControllerDtoNftGenerateRequest,

    /**
     * The NftGeneratorControllerDtoNftGenerateResponse model constructor.
     * @property {module:model/NftGeneratorControllerDtoNftGenerateResponse}
     */
    NftGeneratorControllerDtoNftGenerateResponse,

    /**
     * The NftGeneratorControllerDtoNftImageGenerateRequest model constructor.
     * @property {module:model/NftGeneratorControllerDtoNftImageGenerateRequest}
     */
    NftGeneratorControllerDtoNftImageGenerateRequest,

    /**
     * The NftGeneratorControllerDtoNftImageGenerateResponse model constructor.
     * @property {module:model/NftGeneratorControllerDtoNftImageGenerateResponse}
     */
    NftGeneratorControllerDtoNftImageGenerateResponse,

    /**
     * The NftGeneratorControllerDtoNftImageRecoveryRequest model constructor.
     * @property {module:model/NftGeneratorControllerDtoNftImageRecoveryRequest}
     */
    NftGeneratorControllerDtoNftImageRecoveryRequest,

    /**
     * The NftGeneratorControllerDtoNftImageRecoveryResponse model constructor.
     * @property {module:model/NftGeneratorControllerDtoNftImageRecoveryResponse}
     */
    NftGeneratorControllerDtoNftImageRecoveryResponse,

    /**
     * The NftGeneratorControllerDtoRemoveNftKeyIndexRequest model constructor.
     * @property {module:model/NftGeneratorControllerDtoRemoveNftKeyIndexRequest}
     */
    NftGeneratorControllerDtoRemoveNftKeyIndexRequest,

    /**
     * The NftGeneratorControllerDtoRemoveNftUidIndexRequest model constructor.
     * @property {module:model/NftGeneratorControllerDtoRemoveNftUidIndexRequest}
     */
    NftGeneratorControllerDtoRemoveNftUidIndexRequest,

    /**
     * The NftGrade model constructor.
     * @property {module:model/NftGrade}
     */
    NftGrade,

    /**
     * The NftImageGenerateModel model constructor.
     * @property {module:model/NftImageGenerateModel}
     */
    NftImageGenerateModel,

    /**
     * The NftLevelUpInfoData model constructor.
     * @property {module:model/NftLevelUpInfoData}
     */
    NftLevelUpInfoData,

    /**
     * The NftProperty model constructor.
     * @property {module:model/NftProperty}
     */
    NftProperty,

    /**
     * The NftSeal model constructor.
     * @property {module:model/NftSeal}
     */
    NftSeal,

    /**
     * The NftType model constructor.
     * @property {module:model/NftType}
     */
    NftType,

    /**
     * The NotificationData model constructor.
     * @property {module:model/NotificationData}
     */
    NotificationData,

    /**
     * The PerplayStatisticsControllerDtoItemRequest model constructor.
     * @property {module:model/PerplayStatisticsControllerDtoItemRequest}
     */
    PerplayStatisticsControllerDtoItemRequest,

    /**
     * The PerplayStatisticsControllerDtoItemResponse model constructor.
     * @property {module:model/PerplayStatisticsControllerDtoItemResponse}
     */
    PerplayStatisticsControllerDtoItemResponse,

    /**
     * The PerplayStatisticsControllerDtoItemStatisticsItemData model constructor.
     * @property {module:model/PerplayStatisticsControllerDtoItemStatisticsItemData}
     */
    PerplayStatisticsControllerDtoItemStatisticsItemData,

    /**
     * The PerplayStatisticsControllerDtoMarketGemRequest model constructor.
     * @property {module:model/PerplayStatisticsControllerDtoMarketGemRequest}
     */
    PerplayStatisticsControllerDtoMarketGemRequest,

    /**
     * The PerplayStatisticsControllerDtoMarketGemResponse model constructor.
     * @property {module:model/PerplayStatisticsControllerDtoMarketGemResponse}
     */
    PerplayStatisticsControllerDtoMarketGemResponse,

    /**
     * The PerplayStatisticsControllerDtoMarketGemStatisticsMarketData model constructor.
     * @property {module:model/PerplayStatisticsControllerDtoMarketGemStatisticsMarketData}
     */
    PerplayStatisticsControllerDtoMarketGemStatisticsMarketData,

    /**
     * The PerplayStatisticsControllerDtoMarketItemRequest model constructor.
     * @property {module:model/PerplayStatisticsControllerDtoMarketItemRequest}
     */
    PerplayStatisticsControllerDtoMarketItemRequest,

    /**
     * The PerplayStatisticsControllerDtoMarketItemResponse model constructor.
     * @property {module:model/PerplayStatisticsControllerDtoMarketItemResponse}
     */
    PerplayStatisticsControllerDtoMarketItemResponse,

    /**
     * The PerplayStatisticsControllerDtoMarketItemStatisticsMarketData model constructor.
     * @property {module:model/PerplayStatisticsControllerDtoMarketItemStatisticsMarketData}
     */
    PerplayStatisticsControllerDtoMarketItemStatisticsMarketData,

    /**
     * The PerplayStatisticsControllerDtoMarketVehicleBoxRequest model constructor.
     * @property {module:model/PerplayStatisticsControllerDtoMarketVehicleBoxRequest}
     */
    PerplayStatisticsControllerDtoMarketVehicleBoxRequest,

    /**
     * The PerplayStatisticsControllerDtoMarketVehicleBoxResponse model constructor.
     * @property {module:model/PerplayStatisticsControllerDtoMarketVehicleBoxResponse}
     */
    PerplayStatisticsControllerDtoMarketVehicleBoxResponse,

    /**
     * The PerplayStatisticsControllerDtoMarketVehicleBoxStatisticsMarketData model constructor.
     * @property {module:model/PerplayStatisticsControllerDtoMarketVehicleBoxStatisticsMarketData}
     */
    PerplayStatisticsControllerDtoMarketVehicleBoxStatisticsMarketData,

    /**
     * The PerplayStatisticsControllerDtoMarketVehicleRequest model constructor.
     * @property {module:model/PerplayStatisticsControllerDtoMarketVehicleRequest}
     */
    PerplayStatisticsControllerDtoMarketVehicleRequest,

    /**
     * The PerplayStatisticsControllerDtoMarketVehicleResponse model constructor.
     * @property {module:model/PerplayStatisticsControllerDtoMarketVehicleResponse}
     */
    PerplayStatisticsControllerDtoMarketVehicleResponse,

    /**
     * The PerplayStatisticsControllerDtoMarketVehicleStatisticsMarketData model constructor.
     * @property {module:model/PerplayStatisticsControllerDtoMarketVehicleStatisticsMarketData}
     */
    PerplayStatisticsControllerDtoMarketVehicleStatisticsMarketData,

    /**
     * The PerplayStatisticsControllerDtoNftBoxRequest model constructor.
     * @property {module:model/PerplayStatisticsControllerDtoNftBoxRequest}
     */
    PerplayStatisticsControllerDtoNftBoxRequest,

    /**
     * The PerplayStatisticsControllerDtoNftBoxResponse model constructor.
     * @property {module:model/PerplayStatisticsControllerDtoNftBoxResponse}
     */
    PerplayStatisticsControllerDtoNftBoxResponse,

    /**
     * The PerplayStatisticsControllerDtoNftBoxStatisticsNftBoxData model constructor.
     * @property {module:model/PerplayStatisticsControllerDtoNftBoxStatisticsNftBoxData}
     */
    PerplayStatisticsControllerDtoNftBoxStatisticsNftBoxData,

    /**
     * The PerplayStatisticsControllerDtoNftCarRequest model constructor.
     * @property {module:model/PerplayStatisticsControllerDtoNftCarRequest}
     */
    PerplayStatisticsControllerDtoNftCarRequest,

    /**
     * The PerplayStatisticsControllerDtoNftCarResponse model constructor.
     * @property {module:model/PerplayStatisticsControllerDtoNftCarResponse}
     */
    PerplayStatisticsControllerDtoNftCarResponse,

    /**
     * The PerplayStatisticsControllerDtoNftCarStatisticsNftCarData model constructor.
     * @property {module:model/PerplayStatisticsControllerDtoNftCarStatisticsNftCarData}
     */
    PerplayStatisticsControllerDtoNftCarStatisticsNftCarData,

    /**
     * The PerplayStatisticsControllerDtoNftLevelStatRequest model constructor.
     * @property {module:model/PerplayStatisticsControllerDtoNftLevelStatRequest}
     */
    PerplayStatisticsControllerDtoNftLevelStatRequest,

    /**
     * The PerplayStatisticsControllerDtoNftLevelStatResponse model constructor.
     * @property {module:model/PerplayStatisticsControllerDtoNftLevelStatResponse}
     */
    PerplayStatisticsControllerDtoNftLevelStatResponse,

    /**
     * The PerplayStatisticsControllerDtoNftLevelStatStatisticsNftLevelStatData model constructor.
     * @property {module:model/PerplayStatisticsControllerDtoNftLevelStatStatisticsNftLevelStatData}
     */
    PerplayStatisticsControllerDtoNftLevelStatStatisticsNftLevelStatData,

    /**
     * The PerplayStatisticsControllerDtoNftLevelStatTimeSeriesData model constructor.
     * @property {module:model/PerplayStatisticsControllerDtoNftLevelStatTimeSeriesData}
     */
    PerplayStatisticsControllerDtoNftLevelStatTimeSeriesData,

    /**
     * The PerplayStatisticsControllerDtoTokenRequest model constructor.
     * @property {module:model/PerplayStatisticsControllerDtoTokenRequest}
     */
    PerplayStatisticsControllerDtoTokenRequest,

    /**
     * The PerplayStatisticsControllerDtoTokenResponse model constructor.
     * @property {module:model/PerplayStatisticsControllerDtoTokenResponse}
     */
    PerplayStatisticsControllerDtoTokenResponse,

    /**
     * The PerplayStatisticsControllerDtoTokenStatisticsTokenData model constructor.
     * @property {module:model/PerplayStatisticsControllerDtoTokenStatisticsTokenData}
     */
    PerplayStatisticsControllerDtoTokenStatisticsTokenData,

    /**
     * The PerplayStatisticsControllerDtoTokenStatisticsTokenGraphData model constructor.
     * @property {module:model/PerplayStatisticsControllerDtoTokenStatisticsTokenGraphData}
     */
    PerplayStatisticsControllerDtoTokenStatisticsTokenGraphData,

    /**
     * The PerplayStatisticsControllerDtoUserRequest model constructor.
     * @property {module:model/PerplayStatisticsControllerDtoUserRequest}
     */
    PerplayStatisticsControllerDtoUserRequest,

    /**
     * The PerplayStatisticsControllerDtoUserResponse model constructor.
     * @property {module:model/PerplayStatisticsControllerDtoUserResponse}
     */
    PerplayStatisticsControllerDtoUserResponse,

    /**
     * The PerplayStatisticsControllerDtoUserStatisticsUserData model constructor.
     * @property {module:model/PerplayStatisticsControllerDtoUserStatisticsUserData}
     */
    PerplayStatisticsControllerDtoUserStatisticsUserData,

    /**
     * The PilotMetadata model constructor.
     * @property {module:model/PilotMetadata}
     */
    PilotMetadata,

    /**
     * The PilotPilotRarity model constructor.
     * @property {module:model/PilotPilotRarity}
     */
    PilotPilotRarity,

    /**
     * The PilotPilotStatType model constructor.
     * @property {module:model/PilotPilotStatType}
     */
    PilotPilotStatType,

    /**
     * The PostCreateFailData model constructor.
     * @property {module:model/PostCreateFailData}
     */
    PostCreateFailData,

    /**
     * The PostData model constructor.
     * @property {module:model/PostData}
     */
    PostData,

    /**
     * The PostItemData model constructor.
     * @property {module:model/PostItemData}
     */
    PostItemData,

    /**
     * The PostUserData model constructor.
     * @property {module:model/PostUserData}
     */
    PostUserData,

    /**
     * The RankControllerDtoRankDetailSettingListListData model constructor.
     * @property {module:model/RankControllerDtoRankDetailSettingListListData}
     */
    RankControllerDtoRankDetailSettingListListData,

    /**
     * The RankControllerDtoRankDetailSettingListResponse model constructor.
     * @property {module:model/RankControllerDtoRankDetailSettingListResponse}
     */
    RankControllerDtoRankDetailSettingListResponse,

    /**
     * The RankControllerDtoRankDetailSettingUpdateRequest model constructor.
     * @property {module:model/RankControllerDtoRankDetailSettingUpdateRequest}
     */
    RankControllerDtoRankDetailSettingUpdateRequest,

    /**
     * The RankControllerDtoRankDetailSettingUpdateResponse model constructor.
     * @property {module:model/RankControllerDtoRankDetailSettingUpdateResponse}
     */
    RankControllerDtoRankDetailSettingUpdateResponse,

    /**
     * The ReferralCodeControllerDtoReferralCodeGenerateRequest model constructor.
     * @property {module:model/ReferralCodeControllerDtoReferralCodeGenerateRequest}
     */
    ReferralCodeControllerDtoReferralCodeGenerateRequest,

    /**
     * The ReferralCodeControllerDtoReferralCodeGenerateResponse model constructor.
     * @property {module:model/ReferralCodeControllerDtoReferralCodeGenerateResponse}
     */
    ReferralCodeControllerDtoReferralCodeGenerateResponse,

    /**
     * The ResourceData model constructor.
     * @property {module:model/ResourceData}
     */
    ResourceData,

    /**
     * The SettlementControllerDtoDoSettlementRequest model constructor.
     * @property {module:model/SettlementControllerDtoDoSettlementRequest}
     */
    SettlementControllerDtoDoSettlementRequest,

    /**
     * The SettlementControllerDtoDoSettlementRequiredTransaction model constructor.
     * @property {module:model/SettlementControllerDtoDoSettlementRequiredTransaction}
     */
    SettlementControllerDtoDoSettlementRequiredTransaction,

    /**
     * The SettlementControllerDtoDoSettlementResponse model constructor.
     * @property {module:model/SettlementControllerDtoDoSettlementResponse}
     */
    SettlementControllerDtoDoSettlementResponse,

    /**
     * The SettlementControllerDtoListSettlementDailySettlement model constructor.
     * @property {module:model/SettlementControllerDtoListSettlementDailySettlement}
     */
    SettlementControllerDtoListSettlementDailySettlement,

    /**
     * The SettlementControllerDtoListSettlementRequest model constructor.
     * @property {module:model/SettlementControllerDtoListSettlementRequest}
     */
    SettlementControllerDtoListSettlementRequest,

    /**
     * The SettlementControllerDtoListSettlementResponse model constructor.
     * @property {module:model/SettlementControllerDtoListSettlementResponse}
     */
    SettlementControllerDtoListSettlementResponse,

    /**
     * The SettlementControllerDtoListSettlementType model constructor.
     * @property {module:model/SettlementControllerDtoListSettlementType}
     */
    SettlementControllerDtoListSettlementType,

    /**
     * The SysMaintenanceData model constructor.
     * @property {module:model/SysMaintenanceData}
     */
    SysMaintenanceData,

    /**
     * The SystemControllerDtoApiRoleDeleteRequest model constructor.
     * @property {module:model/SystemControllerDtoApiRoleDeleteRequest}
     */
    SystemControllerDtoApiRoleDeleteRequest,

    /**
     * The SystemControllerDtoApiRoleListRequest model constructor.
     * @property {module:model/SystemControllerDtoApiRoleListRequest}
     */
    SystemControllerDtoApiRoleListRequest,

    /**
     * The SystemControllerDtoApiRoleListResponse model constructor.
     * @property {module:model/SystemControllerDtoApiRoleListResponse}
     */
    SystemControllerDtoApiRoleListResponse,

    /**
     * The SystemControllerDtoApiRoleUpdateRequest model constructor.
     * @property {module:model/SystemControllerDtoApiRoleUpdateRequest}
     */
    SystemControllerDtoApiRoleUpdateRequest,

    /**
     * The SystemControllerDtoFileListRequest model constructor.
     * @property {module:model/SystemControllerDtoFileListRequest}
     */
    SystemControllerDtoFileListRequest,

    /**
     * The SystemControllerDtoFileListResponse model constructor.
     * @property {module:model/SystemControllerDtoFileListResponse}
     */
    SystemControllerDtoFileListResponse,

    /**
     * The SystemControllerDtoFolderListRequest model constructor.
     * @property {module:model/SystemControllerDtoFolderListRequest}
     */
    SystemControllerDtoFolderListRequest,

    /**
     * The SystemControllerDtoFolderListResponse model constructor.
     * @property {module:model/SystemControllerDtoFolderListResponse}
     */
    SystemControllerDtoFolderListResponse,

    /**
     * The SystemControllerDtoGoogleStoreProductImageUpdateRequest model constructor.
     * @property {module:model/SystemControllerDtoGoogleStoreProductImageUpdateRequest}
     */
    SystemControllerDtoGoogleStoreProductImageUpdateRequest,

    /**
     * The SystemControllerDtoGroupRoleCategoryListRequest model constructor.
     * @property {module:model/SystemControllerDtoGroupRoleCategoryListRequest}
     */
    SystemControllerDtoGroupRoleCategoryListRequest,

    /**
     * The SystemControllerDtoGroupRoleCategoryListResponse model constructor.
     * @property {module:model/SystemControllerDtoGroupRoleCategoryListResponse}
     */
    SystemControllerDtoGroupRoleCategoryListResponse,

    /**
     * The SystemControllerDtoGroupRoleUpdateRequest model constructor.
     * @property {module:model/SystemControllerDtoGroupRoleUpdateRequest}
     */
    SystemControllerDtoGroupRoleUpdateRequest,

    /**
     * The SystemControllerDtoMnGnbDetailRequest model constructor.
     * @property {module:model/SystemControllerDtoMnGnbDetailRequest}
     */
    SystemControllerDtoMnGnbDetailRequest,

    /**
     * The SystemControllerDtoMnGnbDetailResponse model constructor.
     * @property {module:model/SystemControllerDtoMnGnbDetailResponse}
     */
    SystemControllerDtoMnGnbDetailResponse,

    /**
     * The SystemControllerDtoMnGnbListResponse model constructor.
     * @property {module:model/SystemControllerDtoMnGnbListResponse}
     */
    SystemControllerDtoMnGnbListResponse,

    /**
     * The SystemControllerDtoMnGnbUploadRequest model constructor.
     * @property {module:model/SystemControllerDtoMnGnbUploadRequest}
     */
    SystemControllerDtoMnGnbUploadRequest,

    /**
     * The SystemControllerDtoMnLnbDetailRequest model constructor.
     * @property {module:model/SystemControllerDtoMnLnbDetailRequest}
     */
    SystemControllerDtoMnLnbDetailRequest,

    /**
     * The SystemControllerDtoMnLnbDetailResponse model constructor.
     * @property {module:model/SystemControllerDtoMnLnbDetailResponse}
     */
    SystemControllerDtoMnLnbDetailResponse,

    /**
     * The SystemControllerDtoMnLnbListRequest model constructor.
     * @property {module:model/SystemControllerDtoMnLnbListRequest}
     */
    SystemControllerDtoMnLnbListRequest,

    /**
     * The SystemControllerDtoMnLnbListResponse model constructor.
     * @property {module:model/SystemControllerDtoMnLnbListResponse}
     */
    SystemControllerDtoMnLnbListResponse,

    /**
     * The SystemControllerDtoMnLnbUploadRequest model constructor.
     * @property {module:model/SystemControllerDtoMnLnbUploadRequest}
     */
    SystemControllerDtoMnLnbUploadRequest,

    /**
     * The SystemControllerDtoMnSubLnbDetailRequest model constructor.
     * @property {module:model/SystemControllerDtoMnSubLnbDetailRequest}
     */
    SystemControllerDtoMnSubLnbDetailRequest,

    /**
     * The SystemControllerDtoMnSubLnbDetailResponse model constructor.
     * @property {module:model/SystemControllerDtoMnSubLnbDetailResponse}
     */
    SystemControllerDtoMnSubLnbDetailResponse,

    /**
     * The SystemControllerDtoMnSubLnbListRequest model constructor.
     * @property {module:model/SystemControllerDtoMnSubLnbListRequest}
     */
    SystemControllerDtoMnSubLnbListRequest,

    /**
     * The SystemControllerDtoMnSubLnbListResponse model constructor.
     * @property {module:model/SystemControllerDtoMnSubLnbListResponse}
     */
    SystemControllerDtoMnSubLnbListResponse,

    /**
     * The SystemControllerDtoMnSubLnbUploadRequest model constructor.
     * @property {module:model/SystemControllerDtoMnSubLnbUploadRequest}
     */
    SystemControllerDtoMnSubLnbUploadRequest,

    /**
     * The SystemControllerDtoSysMaintenanceCreateRequest model constructor.
     * @property {module:model/SystemControllerDtoSysMaintenanceCreateRequest}
     */
    SystemControllerDtoSysMaintenanceCreateRequest,

    /**
     * The SystemControllerDtoSysMaintenanceInfoRequest model constructor.
     * @property {module:model/SystemControllerDtoSysMaintenanceInfoRequest}
     */
    SystemControllerDtoSysMaintenanceInfoRequest,

    /**
     * The SystemControllerDtoSysMaintenanceInfoResponse model constructor.
     * @property {module:model/SystemControllerDtoSysMaintenanceInfoResponse}
     */
    SystemControllerDtoSysMaintenanceInfoResponse,

    /**
     * The SystemControllerDtoSysMaintenanceListRequest model constructor.
     * @property {module:model/SystemControllerDtoSysMaintenanceListRequest}
     */
    SystemControllerDtoSysMaintenanceListRequest,

    /**
     * The SystemControllerDtoSysMaintenanceListResponse model constructor.
     * @property {module:model/SystemControllerDtoSysMaintenanceListResponse}
     */
    SystemControllerDtoSysMaintenanceListResponse,

    /**
     * The SystemControllerDtoSysMaintenanceRemoveRequest model constructor.
     * @property {module:model/SystemControllerDtoSysMaintenanceRemoveRequest}
     */
    SystemControllerDtoSysMaintenanceRemoveRequest,

    /**
     * The SystemControllerDtoSysMaintenanceUpdateRequest model constructor.
     * @property {module:model/SystemControllerDtoSysMaintenanceUpdateRequest}
     */
    SystemControllerDtoSysMaintenanceUpdateRequest,

    /**
     * The TokenType model constructor.
     * @property {module:model/TokenType}
     */
    TokenType,

    /**
     * The VersionResponse model constructor.
     * @property {module:model/VersionResponse}
     */
    VersionResponse,

    /**
     * The WalletControllerDtoContentsWalletListResponse model constructor.
     * @property {module:model/WalletControllerDtoContentsWalletListResponse}
     */
    WalletControllerDtoContentsWalletListResponse,

    /**
     * The WalletControllerDtoDashboardAvailableBalanceRequest model constructor.
     * @property {module:model/WalletControllerDtoDashboardAvailableBalanceRequest}
     */
    WalletControllerDtoDashboardAvailableBalanceRequest,

    /**
     * The WalletControllerDtoDashboardAvailableBalanceResponse model constructor.
     * @property {module:model/WalletControllerDtoDashboardAvailableBalanceResponse}
     */
    WalletControllerDtoDashboardAvailableBalanceResponse,

    /**
     * The WalletControllerDtoDashboardMiningRequest model constructor.
     * @property {module:model/WalletControllerDtoDashboardMiningRequest}
     */
    WalletControllerDtoDashboardMiningRequest,

    /**
     * The WalletControllerDtoDashboardMiningResponse model constructor.
     * @property {module:model/WalletControllerDtoDashboardMiningResponse}
     */
    WalletControllerDtoDashboardMiningResponse,

    /**
     * The WalletControllerDtoDashboardSummaryResponse model constructor.
     * @property {module:model/WalletControllerDtoDashboardSummaryResponse}
     */
    WalletControllerDtoDashboardSummaryResponse,

    /**
     * The WalletControllerDtoDashboardUsageAndDestoryRequest model constructor.
     * @property {module:model/WalletControllerDtoDashboardUsageAndDestoryRequest}
     */
    WalletControllerDtoDashboardUsageAndDestoryRequest,

    /**
     * The WalletControllerDtoDashboardUsageAndDestoryResponse model constructor.
     * @property {module:model/WalletControllerDtoDashboardUsageAndDestoryResponse}
     */
    WalletControllerDtoDashboardUsageAndDestoryResponse,

    /**
     * The WalletControllerDtoDepositAddressRequest model constructor.
     * @property {module:model/WalletControllerDtoDepositAddressRequest}
     */
    WalletControllerDtoDepositAddressRequest,

    /**
     * The WalletControllerDtoDepositAddressResponse model constructor.
     * @property {module:model/WalletControllerDtoDepositAddressResponse}
     */
    WalletControllerDtoDepositAddressResponse,

    /**
     * The WalletControllerDtoDepositRequest model constructor.
     * @property {module:model/WalletControllerDtoDepositRequest}
     */
    WalletControllerDtoDepositRequest,

    /**
     * The WalletControllerDtoNotificationSettingInfoResponse model constructor.
     * @property {module:model/WalletControllerDtoNotificationSettingInfoResponse}
     */
    WalletControllerDtoNotificationSettingInfoResponse,

    /**
     * The WalletControllerDtoNotificationSettingUpdateRequest model constructor.
     * @property {module:model/WalletControllerDtoNotificationSettingUpdateRequest}
     */
    WalletControllerDtoNotificationSettingUpdateRequest,

    /**
     * The WalletControllerDtoTokenSendConditionsInfoResponse model constructor.
     * @property {module:model/WalletControllerDtoTokenSendConditionsInfoResponse}
     */
    WalletControllerDtoTokenSendConditionsInfoResponse,

    /**
     * The WalletControllerDtoTokenSendConditionsUpdateRequest model constructor.
     * @property {module:model/WalletControllerDtoTokenSendConditionsUpdateRequest}
     */
    WalletControllerDtoTokenSendConditionsUpdateRequest,

    /**
     * The WalletControllerDtoXperTgeRequest model constructor.
     * @property {module:model/WalletControllerDtoXperTgeRequest}
     */
    WalletControllerDtoXperTgeRequest,

    /**
    * The AllowedConnectionIpApi service constructor.
    * @property {module:api/AllowedConnectionIpApi}
    */
    AllowedConnectionIpApi,

    /**
    * The CommonApi service constructor.
    * @property {module:api/CommonApi}
    */
    CommonApi,

    /**
    * The DashboardApi service constructor.
    * @property {module:api/DashboardApi}
    */
    DashboardApi,

    /**
    * The InventoryApi service constructor.
    * @property {module:api/InventoryApi}
    */
    InventoryApi,

    /**
    * The ManagerApi service constructor.
    * @property {module:api/ManagerApi}
    */
    ManagerApi,

    /**
    * The ManagerAccountApi service constructor.
    * @property {module:api/ManagerAccountApi}
    */
    ManagerAccountApi,

    /**
    * The NftGeneratorApi service constructor.
    * @property {module:api/NftGeneratorApi}
    */
    NftGeneratorApi,

    /**
    * The PerplayAccountApi service constructor.
    * @property {module:api/PerplayAccountApi}
    */
    PerplayAccountApi,

    /**
    * The PerplayCampaignApi service constructor.
    * @property {module:api/PerplayCampaignApi}
    */
    PerplayCampaignApi,

    /**
    * The PerplayCommunityApi service constructor.
    * @property {module:api/PerplayCommunityApi}
    */
    PerplayCommunityApi,

    /**
    * The PerplayDailySettlementApi service constructor.
    * @property {module:api/PerplayDailySettlementApi}
    */
    PerplayDailySettlementApi,

    /**
    * The PerplayEventsApi service constructor.
    * @property {module:api/PerplayEventsApi}
    */
    PerplayEventsApi,

    /**
    * The PerplayGameApi service constructor.
    * @property {module:api/PerplayGameApi}
    */
    PerplayGameApi,

    /**
    * The PerplayLogApi service constructor.
    * @property {module:api/PerplayLogApi}
    */
    PerplayLogApi,

    /**
    * The PerplayMarketApi service constructor.
    * @property {module:api/PerplayMarketApi}
    */
    PerplayMarketApi,

    /**
    * The PerplayMissionApi service constructor.
    * @property {module:api/PerplayMissionApi}
    */
    PerplayMissionApi,

    /**
    * The PerplayMonitoringApi service constructor.
    * @property {module:api/PerplayMonitoringApi}
    */
    PerplayMonitoringApi,

    /**
    * The PerplayNftApi service constructor.
    * @property {module:api/PerplayNftApi}
    */
    PerplayNftApi,

    /**
    * The PerplayRankApi service constructor.
    * @property {module:api/PerplayRankApi}
    */
    PerplayRankApi,

    /**
    * The PerplayStatisticsApi service constructor.
    * @property {module:api/PerplayStatisticsApi}
    */
    PerplayStatisticsApi,

    /**
    * The ReferralCodeApi service constructor.
    * @property {module:api/ReferralCodeApi}
    */
    ReferralCodeApi,

    /**
    * The SystemApi service constructor.
    * @property {module:api/SystemApi}
    */
    SystemApi,

    /**
    * The TestApi service constructor.
    * @property {module:api/TestApi}
    */
    TestApi,

    /**
    * The WalletApi service constructor.
    * @property {module:api/WalletApi}
    */
    WalletApi
};
